export default {
  message: {
    ABOUT_THE_COMPANY: "Про страховика",
    ADD_TO_FAVORITES: "Зберегти як обране",
    A11Y_TARIFF_BROKER_ACTIONS: "Дії брокера для тарифу",
    A11Y_TARIFF_SIDE_RAIL: "Дії для тарифу",
    TARIFF_MARK_BOOKMARK: "Позначити",
    TARIFF_MARK_BOOKMARKED: "Позначено",
    TARIFF_MARK_ADD_NOTE: "Додати нотатку",
    TARIFF_MARK_NOTE_PLACEHOLDER: "Нотатка до тарифу …",
    TARIFF_MARK_NOTE: "Нотатка",
    TARIFF_MARK_NOTE_TITLE: "Нотатка до цього тарифу",
    TARIFF_MARK_NOTE_SAVE: "Зберегти",
    TARIFF_MARK_NOTE_REMOVE: "Видалити нотатку",
    TARIFF_MARK_NOTE_EDIT: "Редагувати",
    TARIFF_SIDE_RAIL_TOOLTIP_BOOKMARK: "Вибрати тариф для пропозиції",
    TARIFF_SIDE_RAIL_TOOLTIP_BOOKMARKED: "Скасувати вибір",
    TARIFF_SIDE_RAIL_TOOLTIP_NOTE: "Додати нотатку до вибраного тарифу",
    TARIFF_SIDE_RAIL_TOOLTIP_NOTE_EDIT:
      "Редагувати нотатку до вибраного тарифу",
    TARIFF_SIDE_RAIL_TOOLTIP_COMPARE: "Додати тариф до порівняння",
    TARIFF_SIDE_RAIL_TOOLTIP_COMPARE_REMOVE: "Прибрати тариф із порівняння",
    TARIFF_SIDE_RAIL_TOOLTIP_PRINT: "Друкувати тариф",
    TARIFF_SIDE_RAIL_TOOLTIP_CONTACTS: "Показати контакти для тарифу",
    TARIFF_MARK_SEND_OFFER: "Надіслати позначені як пропозицію",
    TARIFF_MARK_SEND_OFFER_SHORT: "Як пропозицію",
    ADDITIONAL_FILTERS: "Додаткові фільтри",
    ACCEPT: "Прийняти",
    ADDRESS_ERROR_MESSAGE: "Потрібні назва вулиці та номер будинку",
    ADDRESS_HOUSE_NUMBER_FORMAT_INVALID: "Невірний формат номера будинку",
    ADDRESS_SEARCH_PLACEHOLDER: "Пошук …",
    ADDRESS_STREET_NUMBER_PLACEHOLDER: "№",
    ADDRESS_STREET_SELECT_FROM_LIST: "Оберіть вулицю зі списку пропозицій.",
    ADDRESS_VALIDATION_FAILED_CONTACT:
      "Не вдалося перевірити вказану адресу. Спробуйте ще раз або напишіть на {supportEmail}",
    ADDRESS_SECTION: "Адреса",
    ADD_TARIFF: "Додати продукт",
    A11Y_COMPARE_ADDED: "{name} додано до порівняння.",
    A11Y_COMPARE_REMOVED: "{name} видалено з порівняння.",
    A11Y_TARIFF_CARD_FOOTER_ACTIONS: "Дії для тарифу {name}",
    A11Y_SEARCH_RESULTS_COUNT:
      "Знайдено {count} тариф. | Знайдено {count} тарифи. | Знайдено {count} тарифів.",
    A11Y_SEARCH_RESULTS_NONE: "Тарифів не знайдено.",
    A11Y_STATEMENT_CONFORMANCE_BODY:
      "Цей вебзастосунок прагне відповідати WCAG 2.2 рівня AA. Реалізація триває; відомі обмеження наведено нижче.",
    A11Y_STATEMENT_CONFORMANCE_HEADING: "Статус відповідності",
    A11Y_STATEMENT_ENFORCEMENT_BODY:
      "Якщо відповідь вас не задовольняє, ви можете звернутися до органу нагляду згідно з німецьким законом про посилення доступності.",
    A11Y_STATEMENT_ENFORCEMENT_HEADING: "Процедура примусового виконання",
    A11Y_STATEMENT_FEEDBACK_BODY:
      "Якщо ви помітили бар’єри доступності, напишіть нам на",
    A11Y_STATEMENT_FEEDBACK_HEADING: "Зворотний зв’язок і контакт",
    A11Y_STATEMENT_FEEDBACK_SUBJECT:
      "Зворотний зв’язок щодо доступності – {brandName}",
    A11Y_STATEMENT_INTRO:
      "{brandName} прагне зробити калькулятор і шляхи оформлення заявок доступними. Цю заяву опубліковано {assessedDate}.",
    A11Y_STATEMENT_LIMITATION_ADS:
      "Вбудована реклама та контент третіх сторін можуть мати бар’єри доступності.",
    A11Y_STATEMENT_LIMITATION_CHAT:
      "Необов’язковий live-чат (Freshchat) надається третьою стороною.",
    A11Y_STATEMENT_LIMITATION_THIRD_PARTY:
      "White-label вбудовування можуть мати інші елементи header, footer і довідки.",
    A11Y_STATEMENT_LIMITATIONS_HEADING: "Відомі обмеження",
    A11Y_STATEMENT_SCOPE_BODY:
      "У сфері застосування: пошук тарифів, перевірка потреб, порівняння продуктів, оформлення заявки (checkout) та підтвердження e-mail у цьому застосунку.",
    A11Y_STATEMENT_SCOPE_HEADING: "Область застосування",
    A11Y_STATEMENT_TITLE: "Заява про доступність",
    ALPHA_ASC: "А → Я",
    ALPHA_ASC_MOBILE: "Страховик (А → Я)",
    ALPHA_DESC: "Я → А",
    ALPHA_DESC_MOBILE: "Страховик (Я → А)",
    ALPHA_MAIN_LABEL: "Страховик",
    ANNUAL_FEE: "Річна вартість",
    APP_POPUP_DEFAULT_TITLE: "Примітка",
    APP_POPUP_DISMISS_DEFAULT: "OK",
    APP_POPUP_NO_CONTENT: "Вміст недоступний.",
    APP_TOAST_CLIPBOARD_TARIFF_FALLBACK: "Продукт: ({legacyId})",
    APP_TOAST_CLIPBOARD_TARIFF_LINE: "Продукт: {main} ({legacyId})",
    APP_TOAST_CLIPBOARD_TOKEN_LINE: "Токен: {token}",
    APP_TOAST_CLIPBOARD_URL_LINE: "URL сторінки: {url}",
    APP_TOAST_CONSOLE_SECTION_HEADER:
      "--- Останній вивід консолі (помилки / попередження) ---",
    APP_TOAST_COPIED: "Скопійовано",
    APP_TOAST_COPY_ERROR: "Скопіювати текст помилки",
    APP_TOAST_EMAIL_REPORT: "Надіслати електронною поштою",
    APP_TOAST_EMAIL_SUBJECT: "Звіт про помилку бронювання",
    APP_TOAST_SESSION_ID_LABEL: "ID сесії:",
    APP_TOAST_TITLE_ERROR: "Помилка",
    APP_TOAST_TITLE_INFO: "Інформація",
    APP_TOAST_TITLE_SUCCESS: "Успіх",
    APP_TOAST_TITLE_WARNING: "Зауваження",
    APPLY_CHANGES: "Застосувати зміни",
    ARIA_LABEL_CLOSE: "Закрити",
    ARIA_LABEL_CLEAR_FIELD: "Очистити поле",
    AWARDS: "Нагороди",
    BACK: "Назад",
    BACK_TOP_TOP: "Нагору",
    BACK_TO_SEARCH: "До пошуку",
    BEST_RATING: "Найкращий рейтинг",
    BOOK: "Подати заявку",
    BOOK_SHORT: "Подати",
    BOOKING_SUMMARY_EMAIL_VERIFICATION_TITLE: "Ще один крок",
    BOOKING_SUMMARY_EMAIL_VERIFICATION_NOTICE:
      "Після натискання <strong>«{cta}»</strong> ми надішлемо лист на <strong>{email}</strong>. Перейдіть за посиланням у листі, щоб завершити заявку.<br/><br/><strong>Порада:</strong> За потреби також перевірте папку «Спам». Пізніше змінити адресу вже неможливо — переконайтеся, що маєте доступ до цієї скриньки.",
    INVITATIO_BOOKING_SUMMARY_EMAIL_VERIFICATION_NOTICE:
      "Після натискання <strong>«{cta}»</strong> ми надішлемо лист на <strong>{email}</strong>. Перейдіть за посиланням у листі, щоб завершити запит.<br/><br/><strong>Порада:</strong> За потреби також перевірте папку «Спам». Пізніше змінити адресу вже неможливо — переконайтеся, що маєте доступ до цієї скриньки.",
    VERIFICATION_EMAIL_ADDRESS_LOCKED_NOTE:
      "Лист для підтвердження надіслано на <strong>{email}</strong>. Цю адресу більше не можна змінити.",
    BOOKING_COMPLETED_INFO_1: `Вашу страхову заявку прийнято. Незабаром ви отримаєте лист підтвердження на <strong>{email}</strong>.
      Якщо листа немає, перевірте папку «Спам».`,
    BOOKING_COMPLETED_INFO_2:
      "Зверніть увагу: захист набуває чинності лише після того, як <strong>{name}</strong> прийме вашу заявку та буде сплачено першу премію.",
    BOOKING_COMPLETED_INFO_4:
      "Вашу заявку збережено в нашій системі під зазначеним нижче номером. Будь ласка, вказуйте його у всіх зверненнях.",
    BOOKING_COMPLETED_INFO_5:
      "Нижче — документи, потрібні для заявки, та корисні посилання. Поліс надішле безпосередньо страхова компанія.",
    BOOKING_COMPLETED_INFO_5_NO_SERVICE_APP:
      "Нижче — документи, потрібні для заявки. Поліс надішле безпосередньо страхова компанія.",
    BOOKING_COMPLETED_PROTOCOL_LINK_LABEL: "Завантажити {documentName}",
    BOOKING_COULD_NOT_COMPLETE_RETRY:
      "Оформлення не вдалося завершити. Спробуйте ще раз.",
    BOOKING_SESSION_ALREADY_CONFIRMED:
      "Вашу заявку вже отримано. Повторно надсилати її не потрібно.",
    BOOKING_SESSION_ALREADY_CONFIRMED_WITH_ID:
      "Вашу заявку вже отримано. Повторно надсилати її не потрібно. Номер заявки: A-{bookingId}",
    BOOKING_EMAIL_FIELD_VALIDATION_FAILED:
      "Не вдалося перевірити електронну адресу. Скористайтеся іншою адресою або зверніться до нас: {supportEmail}",
    BOOKING_ERROR_SUMMARY_TITLE: "Будь ласка, виправте такі відомості:",
    BOOKING_ENTITY_ADD: "+ Додати {unit}",
    BOOKING_ENTITY_REMOVE: "Видалити {unit} {n}",
    BOOKING_FOOTER_BADGE_SUBJECT_TO_INQUIRY: "лише за запитом",
    BOOKING_FOOTER_BOOK_BUTTON_INQUIRY_PAID: "Платний запит",
    BOOKING_FOOTER_BOOK_BUTTON_INQUIRY_SUBMIT: "Надіслати запит",
    BOOKING_FOOTER_PRICE_ON_REQUEST: "за запитом",
    BOOKING_LOADING_INSURED_PERSONS: "Завантаження застрахованих осіб …",
    BOOKING_TRANSITION_LOADING: "Форма завантажується …",
    BOOKING_TRANSITION_LOADING_QUOTE: "Ваш запит пропозиції завантажується …",
    BOOKING_TRANSITION_SUBMITTING: "Ваші дані передаються …",
    SEARCH_RESULTS_LOADING: "Результати пошуку завантажуються …",
    BOOKING_NETWORK_UNCERTAINTY_TOAST:
      "Зв’язок перервано. Якщо заявку прийнято успішно, підтвердження буде на наступній сторінці. Будь ласка, перевірте.",
    BOOKING_PAGE_ONE_HEADING: "Ваші відомості",
    BOOKING_SHUFFLE_ARIA: "Заповнити поля форми заявки випадковими даними",
    BOOKING_SHUFFLE_LABEL: "Заповнити поля випадково",
    BOOKING_SHUFFLE_CHECKBOXES_ARIA:
      "Позначити всі обов’язкові прапорці на сторінці заявки",
    BOOKING_SHUFFLE_CHECKBOXES_LABEL: "Позначити обов’язкові прапорці",
    BOOKING_SHUFFLE_OPTIONS_ARIA: "Особливі випадки для випадкового заповнення",
    BOOKING_SHUFFLE_OPTION_POLICYHOLDER_ADULT: "Страхувальник (дорослий)",
    BOOKING_SHUFFLE_OPTION_ALTERNATIVE_PAYER: "Інший платник внесків",
    BOOKING_PAGE_VALIDATION_UNAVAILABLE:
      "Перевірку не вдалося виконати. Спробуйте ще раз.",
    BOOKING_REFERENCE_PENDING: "створюється",
    BOOKING_TOAST_JUMP_TO_FIRST_ERROR: "Перейти до першої помилки",
    BOOKING_VALIDATION_FAILED_WITH_SUPPORT:
      "Перевірку не пройдено. Спробуйте ще раз або зверніться до підтримки.",
    BOOK_ANOTHER_CONTRACT: "Подати ще одну заявку",
    BOOK_LAST_PAGE: "Надіслати заявку (обов’язково)",
    BROKER_ACCOUNT_SUSPENDED_BODY:
      "Цей обліковий запис посередника нам невідомий або деактивовано. Зверніться до посередника або напишіть на {supportEmail}.",
    BROKER_ACCOUNT_SUSPENDED_TITLE: "Обліковий запис посередника призупинено",
    BROKER_CTA_HOLD_TOOLTIP:
      "Спочатку введіть дані посередника, щоб продовжити.",
    CALCULATOR_NOTE_LINK_TEXT: "Розкриття інформації та страховики-учасники",
    CANCEL: "Скасувати",
    CANCEL_BUTTON: "Скасувати",
    CHECKING_CONTRACT:
      "Ми перевіряємо вашу заявку та пересилаємо її обраному страховику.",
    CLEAR_ALL: "Очистити все",
    COMPANIES: "Страховики",
    INSURER_TEASER_ARIA: "Страховики зі стартовою ціною",
    INSURER_TEASER_SCROLL_LEFT: "Прокрутити страховиків ліворуч",
    INSURER_TEASER_SCROLL_RIGHT: "Прокрутити страховиків праворуч",
    TARIFF_DETAILS_TABS_SCROLL_LEFT: "Прокрутити деталі продукту ліворуч",
    TARIFF_DETAILS_TABS_SCROLL_RIGHT: "Прокрутити деталі продукту праворуч",
    COMPARISON_PAYMENT_OPTIONS_GENERIC_ERROR:
      "Не вдалося завантажити способи оплати.",
    COMPARISON_PAYMENT_OPTIONS_LABEL: "Доступні способи оплати",
    COMPARISON_PAYMENT_OPTIONS_NOT_AVAILABLE: "Недоступно",
    COMPARISON_PAYMENT_OPTIONS_RETRY: "Спробувати ще раз",
    COMPARISON_PAYMENT_OPTIONS_TIMEOUT_ERROR:
      "Не вдалося завантажити способи оплати (час очікування вичерпано). Спробуйте ще раз.",
    COMPARISON_PAYMENT_SELECTED_LABEL: "Ціна за обраний період оплати",
    COMPARISON_PRODUCT_HIGHLIGHTS: "Highlights",
    COMPARISON_REMOVE_TARIFF: "Вилучити продукт з порівняння",
    CONTACT_LINK_TXT: "Контакти",
    CONTINUE: "Далі",
    CONTRACT_CANCELLATION: "Відмовитися від договору",
    CONTRACT_DONE: "Ми отримали вашу заявку",
    CONTRACT_DONE_TARIFF_INFO_TITLE: "Заявлений захист",
    CONTRACT_PROCESSING: "Обробка заявки",
    CONTRACT_PROCESSING_TEXT: "Страховик обробляє вашу заявку.",
    CONTRACT_RENEWAL_APPLICATION_NUMBER_LABEL: "Номер заявки",
    CONTRACT_RENEWAL_APPLICATION_NUMBER_PLACEHOLDER: "напр. 123456",
    CONTRACT_RENEWAL_BIRTH_DATE_LABEL: "Дата народження",
    CONTRACT_RENEWAL_CONTINUE: "Продовжити",
    CONTRACT_RENEWAL_INFORMATIVE:
      "Підтверджую, що завантажив(ла) та прочитав(ла) початкове розкриття для страхових посередників відповідно до § 15 VersVermV (німецьке законодавство). {link}",
    CONTRACT_RENEWAL_INFORMATIVE_REQUIRED:
      "Будь ласка, підтвердіть отримання початкового розкриття.",
    CONTRACT_RENEWAL_INTRO:
      "Щоб продовжити, введіть номер заявки, дату народження та поштовий індекс страхувальника, договір якого ви хочете поновити.",
    CONTRACT_RENEWAL_INVALID_APPLICATION_NUMBER:
      "Будь ласка, введіть коректний номер заявки.",
    CONTRACT_RENEWAL_INVALID_POSTAL_CODE: "Некоректний поштовий індекс",
    CONTRACT_RENEWAL_LOADER_STEP_PREPARE: "Завантаження тарифного калькулятора",
    CONTRACT_RENEWAL_LOADER_STEP_READY: "Перенаправлення до пошуку тарифів",
    CONTRACT_RENEWAL_LOADER_STEP_VERIFY: "Підтвердження заявки",
    CONTRACT_RENEWAL_LOADER_SUBTITLE: "Зачекайте, будь ласка.",
    CONTRACT_RENEWAL_LOADER_TITLE: "Ваш контракт підготовлюється",
    CONTRACT_RENEWAL_POSTAL_CODE_LABEL: "Поштовий індекс",
    CONTRACT_RENEWAL_POSTAL_CODE_PLACEHOLDER: "напр. 60327",
    CONTRACT_RENEWAL_TITLE: "Потрібне підтвердження",
    CONTRACT_SUBMISSION: "Заявку надіслано",
    CORONA_CANCELLATION_DAFAULT_TOOLTIP:
      "<b>Скасування / переривання подорожі</b><br>За цим продуктом ви або застрахована особа захищені, якщо перед виїздом отримаєте позитивний тест на COVID-19 і можете надати підтвердження. Страхування не покриває лише страх подорожі або зараження.",
    CORONA_HEALTH_DAFAULT_TOOLTIP:
      "<b>Медичне страхування подорожі</b><br>За цим продуктом ви захищені, якщо під час подорожі захворієте на COVID-19 і потребуватимете лікування. Додаткові витрати через карантин (наприклад, проживання) не покриваються.",
    CORONA_INSURED: "COVID-19 включено",
    CORONA_NOT_INSURED: "COVID-19 не включено",
    CORONA_PARTIALLY_INSURED: "Див. примітку щодо COVID-19",
    CORONA_TAG_HEADING_CANCEL: "Скасування / переривання подорожі",
    CORONA_TAG_HEADING_HEALTH: "Медичне страхування подорожі",
    COVERAGE_FEATURES: "Особливості покриття",
    DATA_PROTECTION: "Конфіденційність",
    DOCUMENTS: "Документи",
    DOCUMENTS_LOADING: "Завантаження документів …",
    DOWNLOAD: "Завантажити",
    DOWNLOAD_ALL: "Завантажити всі документи як ZIP-файл",
    DOWNLOAD_PROTOCOL: "Завантажити запис консультації",
    EARLIEST_POSSIBLE_START: "найраніший можливий початок",
    EARLIEST_POSSIBLE: "найраніше",
    EMAIL_ADDRESS: "Адреса електронної пошти",
    EMAIL_ADDRESS_OF_THE_RECIPIENT: "Отримувач",
    CC: "У КОПІЇ",
    EMAIL_FORM_PLACEHOLDER: "напр. max.mustermann{'@'}example.com",
    EMAIL_FORM_CC_HELPER: "Підтверджуйте кілька адрес клавішею Enter",
    EMAIL_FORM_CC_PLACEHOLDER: "Додати одну або кілька електронних адрес …",
    EMAIL_FORM_FIELD_EMAIL: "Електронна пошта",
    EMAIL_FORM_MESSAGE_LABEL: "Повідомлення",
    EMAIL_IS_REQUIRED: "Потрібна електронна пошта",
    ENTER_CORRECT_EMAIL: "Введіть коректну електронну адресу",
    FILE_ERROR_MAX_COUNT:
      "Можна завантажити максимум {count} файл. | Можна завантажити максимум {count} файли. | Можна завантажити максимум {count} файлів.",
    FILE_ERROR_SIZE:
      "Розмір вибраного файлу перевищує допустимий. Максимальний розмір файлу: {maxSizeMb} МБ.",
    FILE_ERROR_FORMAT:
      "Формат вибраного файлу не підтримується. Дозволені типи файлів: {allowedTypes}.",
    FILE_UPLOAD: "Вибрати файл",
    FILE_UPLOAD_SMARTPHONE: "Завантажити зі смартфона",
    FILE_UPLOAD_SMARTPHONE_TITLE: "Завантажити документ зі смартфона",
    FILE_UPLOAD_SMARTPHONE_DESCRIPTION:
      "Відскануйте QR-код камерою смартфона. Мобільна сторінка відкриє саме це поле завантаження; вхід у систему не потрібен.",
    FILE_UPLOAD_SMARTPHONE_ACTIVE: "Активний · залишилося {time} хв.",
    FILE_UPLOAD_SMARTPHONE_ACTIVE_SECONDS: "Активний · залишилося {time} сек.",
    FILE_UPLOAD_SMARTPHONE_EXPIRED: "Термін дії QR-коду минув",
    FILE_UPLOAD_SMARTPHONE_CLOSE: "Закрити QR-код",
    FILE_UPLOAD_SMARTPHONE_REFRESH: "Оновити QR-код",
    FILE_UPLOAD_SMARTPHONE_WAITING: "Очікування завантаження зі смартфона…",
    FILE_UPLOAD_SMARTPHONE_UPLOADED: "Завантажено зі смартфона",
    FILE_UPLOAD_SMARTPHONE_SUCCESS_TITLE: "Документ успішно завантажено",
    FILE_UPLOAD_SMARTPHONE_UPLOADED_AT: "Завантажено {date}",
    FILE_UPLOAD_SMARTPHONE_FILE_SIZE: "Розмір файлу: {size}",
    FILE_UPLOAD_SMARTPHONE_REPLACE: "Замінити",
    FILE_UPLOAD_REMOVE: "Видалити файл {fileName}",
    FILE_UPLOAD_SUCCESS: "Файл {fileName} успішно завантажено",
    FILTERS: "Фільтри",
    FILTER_ACTION: "Фільтрувати",
    FILTER_BY: "Фільтрувати за:",
    CLEAR: "Очистити",
    LINKS: "Посилання",
    RESULTS_CONTROLS_TOOLBAR: "Сортувати та фільтрувати результати",
    FOOTER_ACCESSIBILITY_LINK: "Доступність",
    FOOTER_AGB_LINK: "Умови",
    FOOTER_COOKIES_LINK: "Файли cookie",
    FOOTER_COPYRIGHT: "© {brandName}",
    FOOTER_MORE_LINKS: "Інші посилання",
    FORM_CONTAINS_ERRORS_TEXT:
      "У формі є помилки. Виправте їх, щоб продовжити.",
    BOOKING_FOOTER_ERROR_HINT_TOOLTIP:
      "У формі є помилки. Натисніть тут, щоб перейти до першої помилки.",
    BOOKING_FOOTER_ERRORS_FOUND_ONE: "Знайдено 1 помилку",
    BOOKING_FOOTER_ERRORS_FOUND_MANY: "Знайдено {count} помилок",
    BOOKING_FOOTER_LANDMARK_LABEL: "Тариф і навігація заявки",
    FROM: "від",
    FULLY_CONTAINED: "Включено",
    GENERAL_BOOKING_ERROR: "Під час надсилання даних сталася помилка.",
    GET_QUOTES_NOW: "Отримати пропозиції",
    GROUP_TRAVEL_AGE_GROUPS_TOOLTIP:
      "Групові туристичні продукти для груп 10–150 осіб (6–150 у залізничних подорожах). Вкажіть вік мандрівників.<br> Враховується <u>вік на момент оформлення страхування.</u>",
    IBAN_VALIDATION_FAILED: "Введіть коректний IBAN",
    R_PARAMETER_VALIDATION_EMPTY:
      "Параметр афіліата відсутній. Будь ласка, перевірте посилання.",
    R_PARAMETER_VALIDATION_INVALID_FORMAT:
      "Параметр афіліата має невірний формат. Будь ласка, перевірте посилання.",
    R_PARAMETER_VALIDATION_INACTIVE_AFFILIATE:
      "Афіліат більше не активний. Будь ласка, перевірте посилання.",
    R_PARAMETER_VALIDATION_LOOKUP_FAILED:
      "Афіліата не вдалося знайти. Будь ласка, перевірте посилання.",
    R_PARAMETER_VALIDATION_PROCESSING:
      "Параметр афіліата не вдалося обробити. Будь ласка, спробуйте ще раз.",
    R_PARAMETER_VALIDATION_RAW_AFFILIATE_ID:
      "Афіліата зіставлено за сирим ідентифікатором. Можна продовжити — бронювання не блокується.",
    R_PARAMETER_VALIDATION_FAILED:
      "Параметр афіліата недійсний. Будь ласка, перевірте посилання.",
    IMPORTANT_INFORMATION: "Важлива інформація",
    IMPORTANT_NOTES: "Важливі примітки",
    IMPORTANT_NOTICE: "Важливе повідомлення",
    IMPORTANT_PRE_REQUIREMENTS: "Особливі передумови",
    IMPRINT: "Юридична інформація",
    INACTIVE_TARIFFS_LEARN_MORE: "Докладніше …",
    INACTIVE_TARIFFS_MODAL_TITLE: "Тимчасово недоступні продукти",
    INACTIVE_TARIFFS_NOTICE_MULTIPLE:
      "Примітка: тимчасово не можна подати заявку на {count} продуктів через нас.",
    INACTIVE_TARIFFS_NOTICE_SINGLE:
      "Примітка: тимчасово не можна подати заявку на один продукт через нас.",
    INFO: "Інфо",
    CONTACTS: "Контакти",
    INFO_LINK_TEXT_SHORT: "Переддоговірне розкриття",
    INITIAL_INFORMATION_LINK: "Початкове розкриття (§ 15 VersVermV)",
    INSURANCES: "Страховики",
    INSURANCE_POLICY: "Продукт",
    INSURANCE_POLICY_TEXT:
      "Страховик надішле страхові документи вам (страхувальнику) поштою або електронною поштою.",
    INVITATIO_BOOKING_COMPLETED_INFO_1: `Ваш запит успішно отримано, і незабаром ви отримаєте підтвердження електронною поштою на <strong>{email}</strong>.
      Якщо листа немає, перевірте папку «Спам».`,
    INVITATIO_BOOKING_COMPLETED_INFO_2:
      "Зверніть увагу: страховий захист набуває чинності лише після того, як <strong>{name}</strong> прийме ваш запит і буде сплачено першу премію.",
    INVITATIO_BOOKING_COMPLETED_INFO_4:
      "Ваш запит зберігається в нашій системі під зазначеним нижче ідентифікатором. Будь ласка, вказуйте його в усіх зверненнях.",
    INVITATIO_BOOKING_COMPLETED_INFO_5:
      "Тут зібрані необхідні документи щодо вашого запиту та корисні посилання. Страховий поліс ви отримаєте безпосередньо від страховика.",
    INVITATIO_BOOKING_COMPLETED_INFO_5_NO_SERVICE_APP:
      "Тут зібрані необхідні документи щодо вашого запиту. Страховий поліс ви отримаєте безпосередньо від страховика.",
    INVITATIO_BOOKING_COULD_NOT_COMPLETE_RETRY:
      "Запит пропозиції не вдалося завершити. Спробуйте ще раз.",
    INVITATIO_BOOKING_SESSION_ALREADY_CONFIRMED:
      "Ваш запит вже отримано. Повторно надсилати його не потрібно.",
    INVITATIO_BOOKING_SESSION_ALREADY_CONFIRMED_WITH_ID:
      "Ваш запит вже отримано. Повторно надсилати його не потрібно. Номер запиту: A-{bookingId}",
    INVITATIO_BOOKING_FOOTER_PRICE_ON_REQUEST: "за запитом",
    INVITATIO_BOOKING_NETWORK_UNCERTAINTY_TOAST:
      "Зв’язок перервано. Якщо запит пропозиції прийнято успішно, підтвердження буде на наступній сторінці. Будь ласка, перевірте.",
    INVITATIO_BOOK_ANOTHER_CONTRACT: "Подати ще один запит",
    INVITATIO_BOOK_LAST_PAGE: "Надіслати запит пропозиції",
    INVITATIO_CHECKING_CONTRACT:
      "Ми перевіряємо ваш запит і передаємо його обраному страховику.",
    INVITATIO_CONTRACT_DONE: "Ми отримали ваш запит",
    INVITATIO_CONTRACT_DONE_TARIFF_INFO_TITLE: "Ваш бажаний захист",
    INVITATIO_CONTRACT_PROCESSING: "Оформлення полісу",
    INVITATIO_CONTRACT_PROCESSING_TEXT: "Страховик обробляє ваш запит.",
    INVITATIO_CONTRACT_SUBMISSION: "Перевірка запиту",
    INVITATIO_INSURANCE_POLICY: "Страховий поліс",
    INVITATIO_INSURANCE_POLICY_TEXT:
      "Після перевірки запиту страховик повідомить вас про наступні кроки та за потреби надішле договірні документи поштою або електронною поштою.",
    INVITATIO_PLEASE_WAIT_CONTRACT_NUM:
      "Зачекайте, будь ласка, поки згенерується ваш ідентифікатор.",
    INVITATIO_TARIFF_BLOCK_BOOK: "Запитати пропозицію",
    INVITATIO_VERIFICATION_ALREADY_VERIFIED_P1:
      "Вашу електронну адресу вже підтверджено. Ваш запит із номером <strong>{bookingId}</strong> успішно отримано.",
    INVITATIO_VERIFICATION_BOOKING_PENDING_BODY:
      "Щоб ми могли переслати ваш запит із номером <strong>{bookingData}</strong> до <strong>{insurerName}</strong>, натисніть посилання <strong>«Підтвердити електронну адресу»</strong> в листі, який ми щойно надіслали на <strong>{email}</strong>. Якщо листа немає, перевірте папку «Спам».",
    INVITATIO_VERIFICATION_BOOKING_PENDING_FORWARD_NOTE:
      "Ми пересилаємо ваш запит лише після успішного підтвердження електронної пошти.",
    INVITATIO_VERIFICATION_EMAIL_CONFIRM_EXPIRED_BODY:
      "Посилання для підтвердження вашого запиту з номером <strong>{bookingId}</strong> більше не дійсне. Ми не обробляємо цей запит далі.",
    INVITATIO_VERIFICATION_SUCCESS_COVER_NOTICE:
      "<strong>Зверніть увагу:</strong> страховий захист набуває чинності лише після того, як <strong>{insurerName}</strong> прийме та підтвердить ваш запит. Застосовні лише умови, зазначені в полісі. Наведені нами характеристики оновлюються з усією ретельністю; для договору вирішальним залишається обсяг покриття зі страхових умов.",
    INVITATIO_VERIFICATION_SUCCESS_RECEIVED_BODY:
      "Ваш запит із номером <strong>{bookingId}</strong> успішно отримано. Незабаром ви отримаєте підтвердження електронною поштою на <strong>{policyHolderEmail}</strong>. Якщо листа немає, перевірте папку «Спам».",
    INVITATIO_VERIFICATION_SUCCESS_TITLE: "Ваш запит зараз обробляється",
    INVITATIO_VERIFICATION_POLICY_START_CHANGED_BODY:
      "Обрана раніше дата початку страхування більше недоступна для цього тарифу. Ваш запит можна продовжити лише з новою датою початку та оновленим внеском.",
    INVITATIO_VERIFICATION_POLICY_START_CHANGED_NOTE:
      "Запит буде оброблено далі лише після вашого підтвердження.",
    INVITATIO_VERIFICATION_POLICY_START_BOOKING_LABEL: "Номер запиту: ",
    INVITATIO_SEPA_VERIFICATION_BOOKING_PENDING_BODY:
      "Підтвердьте, будь ласка, що ми можемо стягувати внески з вашого рахунку через SEPA. У листі на <strong>{email}</strong> натисніть посилання підтвердження (наприклад <strong>«SEPA»</strong>) стосовно вашого запиту з номером <strong>{bookingData}</strong> до <strong>{insurerName}</strong>. Якщо листа немає, перевірте «Спам».",
    INVITATIO_SEPA_VERIFICATION_BOOKING_PENDING_FORWARD_NOTE:
      "Без свогочасного підтвердження SEPA-мандату стягнення внесків планом SEPA неможливі. Ми продовжимо обробку запиту лише після успішного підтвердження.",
    INVITATIO_SEPA_VERIFICATION_EMAIL_CONFIRM_EXPIRED_BODY:
      "Посилання для підтвердження SEPA-мандата щодо вашого запиту <strong>{bookingId}</strong> більше не дійсне. Ми не обробляємо цей запит далі в цьому контексті.",
    INVITATIO_SEPA_VERIFICATION_ALREADY_VERIFIED_P1:
      "SEPA-мандат вже підтверджено. Ваш запит із номером <strong>{bookingId}</strong> успішно отримано.",
    INVITATIO_SEPA_VERIFICATION_SUCCESS_MESSAGE:
      '<p>SEPA-мандат на погашення внеску за запитом <strong>{bookingId}</strong> збережено.</p><p>Дякуємо за згоду на стягнення внесків.</p><p>Ваш договір набирає чинності зі сплати першого внеску.</p><p class="mb-0">З вітанням<br />Служба підтримки</p>',
    SEPA_VERIFICATION_SUCCESS_MESSAGE:
      '<p>SEPA-мандат на погашення внеску за заявкою <strong>{bookingId}</strong> збережено.</p><p>Дякуємо за згоду на стягнення внесків.</p><p>Ваш(і) договір(и) набирають чинності зі сплати першого внеску.</p><p class="mb-0">З вітанням<br />Служба підтримки</p>',
    SEPA_VERIFICATION_ALREADY_VERIFIED_P1:
      "SEPA-мандат вже підтверджено. Страхову заявку з номером <strong>{bookingId}</strong> прийнято.",
    SEPA_VERIFICATION_ALREADY_VERIFIED_TITLE: "SEPA-мандат вже підтверджено",
    SEPA_VERIFICATION_BOOKING_PENDING_BODY:
      "Підтвердьте, будь ласка, що ми можемо стягувати внески з вашого рахунку через SEPA. У листі на <strong>{email}</strong> натисніть посилання підтвердження (наприклад <strong>«SEPA»</strong>) стосовно заявки з номером <strong>{bookingData}</strong> до <strong>{insurerName}</strong>. Якщо листа немає, перевірте «Спам».",
    SEPA_VERIFICATION_BOOKING_PENDING_FORWARD_NOTE:
      "Без свогочасного підтвердження SEPA-мандату стягнення внесків планом SEPA неможливі. Ми продовжимо обробку страхової заявки лише після успішного підтвердження.",
    SEPA_VERIFICATION_BOOKING_PENDING_TITLE: "Підтвердіть SEPA-авторисання",
    SEPA_VERIFICATION_EMAIL_CONFIRM_EXPIRED_BODY:
      "Посилання для підтвердження SEPA-мандата щодо страхової заявки <strong>{bookingId}</strong> більше не дійсне. Ми далі не обробляємо оформлення в цьому контексті.",
    SEPA_VERIFICATION_LINK_EXPIRY_NOTICE:
      "<strong>Посилання для SEPA-мандата дійсне лише до {date} 23:59.</strong>",
    SEPA_VERIFICATION_SUCCESS_TITLE: "Підтвердження вдале!",
    INVITATIO_WHAT_IS_NEXT: "Що далі",
    INVITATIO_WHAT_IS_NEXT_SUBMIT_TITLE: "Подати запит",
    INVITATIO_WHAT_IS_NEXT_SUBMIT_TEXT: "Ми отримали ваш запит.",
    INVITATIO_WHAT_IS_NEXT_PROGRESS_EMAIL_VALIDATION_TEXT:
      "Підтвердіть e-mail за посиланням у нашому листі.",
    INVITATIO_WHAT_IS_NEXT_EMAIL_VALIDATION_TITLE: "Підтвердити e-mail",
    INVITATIO_WHAT_IS_NEXT_EMAIL_VALIDATION_TEXT:
      "Будь ласка, підтвердіть свою електронну адресу за посиланням у листі, який ми надіслали на <strong>{email}</strong>. Лише після цього ми зможемо передати ваш запит далі.",
    INVITATIO_WHAT_IS_NEXT_REQUEST_REVIEW_TITLE: "Перевірка запиту",
    INVITATIO_WHAT_IS_NEXT_PROGRESS_REQUEST_REVIEW_TEXT:
      "Ми перевіряємо ваш запит на повноту.",
    INVITATIO_WHAT_IS_NEXT_REQUEST_REVIEW_TEXT:
      "Ми перевіряємо ваш запит на повноту та правдоподібність.",
    INVITATIO_WHAT_IS_NEXT_TRANSMISSION_TITLE: "Передача",
    INVITATIO_WHAT_IS_NEXT_PROGRESS_TRANSMISSION_TEXT:
      "Ми передаємо ваш запит страховику.",
    INVITATIO_WHAT_IS_NEXT_TRANSMISSION_TEXT:
      "Ми передаємо ваш запит обраній страховій компанії.",
    INVITATIO_WHAT_IS_NEXT_POLICY_ISSUANCE_TITLE: "Оформлення полісу",
    INVITATIO_WHAT_IS_NEXT_PROGRESS_POLICY_ISSUANCE_TEXT:
      "Страховик обробляє ваш запит.",
    INVITATIO_WHAT_IS_NEXT_PROGRESS_INSURANCE_POLICY_TEXT:
      "Страховик надсилає вам документи.",
    INVITATIO_YOUR_CONTRACT_NUM: "Ваш запит",
    IS_REQUIRED_FIELD: "Обов’язкове поле",
    IS_WRONG_FORMAT: "некоректний формат",
    I_HAVE_CONTRACT_TEXT_PART_4_COVOMO:
      "Я підтверджую та погоджуюся з умовами, представленими посередником {brandName}.",
    LEGAL_MATTERS: "Правова інформація",
    LINKOUT_APPLICANT_HEADING: "Заявник",
    LINKOUT_DATE_PLACEHOLDER: "ДД.ММ.РРРР",
    LINKOUT_INTRO_COMPARISON:
      "Ви залишаєте калькулятор порівняння й будете перенаправлені на онлайн-подачу заявки постачальника продукту {insurer}.",
    LINKOUT_INTRO_POLICYHOLDER:
      "Щоб ми могли відстежувати й супроводжувати вашу заявку, заповніть наведені нижче дані страхувальника.",
    LINKOUT_INTRO_POLICYHOLDER_NO_SERVICE_APP:
      "Будь ласка, заповніть наведені нижче дані страхувальника.",
    LINKOUT_OVERLAY_APPLICANT_DETAILS: "Дані заявника",
    LINKOUT_OVERLAY_CLOSE_WINDOW: "Закрити вікно",
    LINKOUT_OVERLAY_REDIRECTING: "Вас перенаправляють …",
    LINKOUT_PRIVACY_CONSENT:
      "Продовжуючи, ви підтверджуєте, що ознайомилися з {privacyLink} постачальника продукту та погоджуєтеся на обробку ваших даних {insurer}.",
    LINKOUT_PRIVACY_LINK_TEXT: "політикою конфіденційності",
    LINKOUT_QUOTE_COMPLETED: "Ваш запит пропозиції завершено.",
    LINKOUT_QUOTE_INTRO_LINE:
      "Пропозиція щодо міжнародного медичного страхування",
    LINKOUT_REDIRECT_CLICK_HERE: "натисніть тут",
    LINKOUT_REDIRECT_COUNTDOWN: "Вас перенаправлять через {count} секунд.",
    LINKOUT_REDIRECT_FALLBACK:
      "Якщо перенаправлення не відбулося автоматично, {link}.",
    LINK_HERE: "тут",
    MAIN_SERVICES: "Ключові переваги",
    MARKETING_AFFILIATE_CHECKBOX: `Згідно зі ст. 15 GDPR ви можете вимагати від {0} інформацію про збережені персональні дані.
      Згідно зі ст. 17 GDPR ви можете вимагати виправлення, видалення або обмеження обробки. Ви можете заперечити будь-коли без пояснень і змінити або відкликати згоду на майбутнє. Сплачуються лише базові тарифи передачі. Заперечення надсилайте на: {1} або за адресою вище.
      Повна інформація про конфіденційність для {2} доступна `,
    MARKETING_CHECKBOX:
      "Також погоджуюся, що партнер {brandName} {0}, {1}, {2}, може надсилати мені електронні листи з інформацією та пропозиціями страхових продуктів у маркетингових цілях.",
    MOBILE_FILTERS_MORE: "Більше фільтрів",
    MOBILE_OVERLAY_FIND_TARIFFS: "Знайти продукти",
    MOBILE_OVERLAY_SHOW_RESULTS:
      "Показати {count} результат | Показати {count} результати | Показати {count} результатів",
    MOBILE_UPLOAD_TITLE: "Завантажити документ",
    MOBILE_UPLOAD_LOADING: "Посилання для завантаження завантажується …",
    MOBILE_UPLOAD_REFERENCE: "Номер заявки",
    MOBILE_UPLOAD_REQUIRED_DOCUMENT: "Необхідний документ",
    MOBILE_UPLOAD_SELECT_FILE: "Вибрати файл",
    MOBILE_UPLOAD_FILE_HINT:
      "JPG, PNG або PDF · максимальний розмір {maxSizeMb} МБ",
    MOBILE_UPLOAD_CONFIRM: "Завантажити й підтвердити",
    MOBILE_UPLOAD_UPLOADING: "Документ завантажується …",
    MOBILE_UPLOAD_SUCCESS: "Документ успішно передано. Це вікно можна закрити.",
    MOBILE_UPLOAD_INTRO:
      "Вашу заявку розпізнано. Завантажте, будь ласка, зазначений документ:",
    MOBILE_UPLOAD_INVALID: "Це посилання для завантаження недійсне.",
    MOBILE_UPLOAD_EXPIRED:
      "Термін дії цього посилання минув або його вже було використано. Відкрийте новий QR-код на комп’ютері.",
    MOBILE_UPLOAD_LOAD_ERROR:
      "Не вдалося завантажити посилання. Спробуйте ще раз.",
    MOBILE_UPLOAD_TYPE_ERROR: "Виберіть файл у форматі JPG, PNG або PDF.",
    MOBILE_UPLOAD_SIZE_ERROR:
      "Вибраний файл завеликий. Максимальний розмір файлу — {maxSizeMb} МБ.",
    MOBILE_UPLOAD_INFECTED_ERROR:
      "Файл не вдалося прийняти з міркувань безпеки. Виберіть інший файл.",
    MOBILE_UPLOAD_FILE_REQUIRED_ERROR: "Будь ласка, виберіть файл.",
    MOBILE_UPLOAD_SERVER_ERROR:
      "Не вдалося передати документ. Спробуйте ще раз.",
    MOBILE_UPLOAD_RETRY: "Спробувати ще раз",
    MOBILE_UPLOAD_SELECT_ANOTHER: "Вибрати інший файл",
    MULTISELECT_SELECTED: "{count} обрано",
    NOT_INCLUDED: "Не включено",
    NO_CONSULTANCY_POPUP_TEXT_COVOMO_APPLICANT:
      "<p>я самостійно заповнив(ла) заявку та обрав(ла) продукт з конкретної потреби. Буде підготовлено запис консультації щодо вибору продукту та онлайн-сесії. Категорично відмовляюся від очних консультацій та консультацій щодо інших страхових продуктів.</p>",
    NO_CONSULTANCY_POPUP_TEXT_COVOMO_BROKER:
      "<p>я заповнив(ла) заявку від імені клієнта та обрав(ла) продукт з конкретної потреби. Буде підготовлено запис консультації. Клієнт категорично відмовляється від очних консультацій та консультацій щодо інших страхових продуктів. Підтверджую повноваження робити цю заяву від імені клієнта.</p>",
    NO_FILE_DETECTED: "Файл не вибрано",
    NO_OPTIONS_IN_SELECT: "Немає доступних варіантів",
    NO_TARIFFS: "Жоден продукт не відповідає поточному пошуку.",
    ERSTINFORMATION_CONSENT_REQUIRED_BEFORE_SEARCH:
      "Підтвердьте початкову інформацію, щоб розпочати пошук продуктів.",
    NO_TARIFFS_FOR_SELECTED_FILTERS:
      "Жоден продукт не відповідає поточному пошуку та фільтрам.",
    NO_TARIFFS_FOUND: "Продуктів не знайдено",
    NO_VALUE_FOUND: "Нічого не знайдено",
    OPTIONAL: "необов’язково",
    PAGE_HEADING_ACCESSIBILITY: "Заява про доступність",
    PAGE_HEADING_ASSESSMENT: "Оцінка ризику",
    PAGE_HEADING_BOOKING: "Заява",
    PAGE_HEADING_BOOKING_COMPLETE: "Заяву завершено",
    PAGE_HEADING_BOOKING_REVIEW: "Перевірка заявки",
    PAGE_HEADING_BOOKING_STEP2: "Заява – оплата",
    PAGE_HEADING_COMPARISON: "Порівняння продуктів",
    PAGE_HEADING_CONTRACT_RENEWAL: "Продовження контракту",
    PAGE_HEADING_DEFAULT: "Калькулятор порівняння",
    PAGE_HEADING_NOT_FOUND: "Сторінку не знайдено",
    PAGE_HEADING_RESUME_BOOKING: "Продовжити заявку",
    PAGE_HEADING_SEARCH: "Пошук тарифів",
    PAGE_HEADING_TARIFF: "Деталі тарифу",
    PAGE_HEADING_VERIFICATION: "Підтвердження e-mail",
    PAGE_HEADING_WIZARD: "Перевірка потреб",
    PAGE_HEADING_STEP_BY_STEP: "Крок за кроком",
    PAGE_TITLE_ACCESSIBILITY: "Заява про доступність {'|'} {siteName}",
    PAGE_TITLE_ASSESSMENT: "Оцінка ризику {'|'} {siteName}",
    PAGE_TITLE_BOOKING: "Заява {'|'} {siteName}",
    PAGE_TITLE_BOOKING_COMPLETE: "Заяву завершено {'|'} {siteName}",
    PAGE_TITLE_BOOKING_REVIEW: "Перевірка заявки {'|'} {siteName}",
    PAGE_TITLE_BOOKING_STEP2: "Заява – оплата {'|'} {siteName}",
    PAGE_TITLE_COMPARISON: "Порівняння продуктів {'|'} {siteName}",
    PAGE_TITLE_CONTRACT_RENEWAL: "Продовження контракту {'|'} {siteName}",
    PAGE_TITLE_DEFAULT: "Калькулятор порівняння {siteName}",
    PAGE_TITLE_MOBILE_UPLOAD: "Завантажити документ {'|'} {siteName}",
    PAGE_DESCRIPTION_MOBILE_UPLOAD:
      "Безпечно завантажте документ зі смартфона.",
    PAGE_TITLE_NOT_FOUND: "Сторінку не знайдено {'|'} {siteName}",
    PAGE_TITLE_RESUME_BOOKING: "Продовжити заявку {'|'} {siteName}",
    PAGE_TITLE_SEARCH: "Пошук тарифів {'|'} {siteName}",
    PAGE_TITLE_TARIFF: "Деталі тарифу {'|'} {siteName}",
    PAGE_TITLE_VERIFICATION: "Підтвердження e-mail {'|'} {siteName}",
    PAGE_TITLE_WIZARD: "Перевірка потреб {'|'} {siteName}",
    PAGE_TITLE_STEP_BY_STEP: "Крок за кроком {'|'} {siteName}",
    PAGE_DESCRIPTION_DEFAULT:
      "Порівнюйте страхові тарифи та оформлюйте поліс онлайн – {brandName}.",
    PAGE_DESCRIPTION_SEARCH:
      "Порівняйте тарифи, перевірте умови та оформіть поліс онлайн – {brandName}.",
    PAGE_DESCRIPTION_WIZARD:
      "Підберіть відповідне страхове покриття за допомогою перевірки потреб – {brandName}.",
    PAGE_DESCRIPTION_COMPARISON:
      "Порівняйте обрані тарифи та умови детально – {brandName}.",
    PAGE_DESCRIPTION_TARIFF: "Деталі тарифу, умови та ціни – {brandName}.",
    PAGE_DESCRIPTION_ASSESSMENT:
      "Оцінка ризику для вашої страхової заявки – {brandName}.",
    PAGE_DESCRIPTION_BOOKING:
      "Заповніть та надішліть страхову заявку онлайн – {brandName}.",
    PAGE_DESCRIPTION_BOOKING_STEP2:
      "Введіть платіжні дані для страхової заявки – {brandName}.",
    PAGE_DESCRIPTION_BOOKING_REVIEW:
      "Перевірте та надішліть заявку – {brandName}.",
    PAGE_DESCRIPTION_BOOKING_COMPLETE:
      "Вашу страхову заявку успішно надіслано – {brandName}.",
    PAGE_DESCRIPTION_VERIFICATION:
      "Підтвердіть адресу електронної пошти для страхової заявки – {brandName}.",
    PAGE_DESCRIPTION_RESUME_BOOKING:
      "Продовжити перервану страхову заявку – {brandName}.",
    PAGE_DESCRIPTION_NOT_FOUND: "Запитану сторінку не знайдено – {brandName}.",
    PAGE_DESCRIPTION_ACCESSIBILITY:
      "Заява про доступність цього калькулятора порівняння – {brandName}.",
    PAGE_NOT_FOUND: "Сторінку не знайдено",
    PAGE_NOT_FOUND_BUTTON: "Повернутися до порівняння",
    PAGE_NOT_FOUND_TEXT: "Сторінку не знайдено або посилання більше не дійсне.",
    PARTIALLY_INCLUDED: "Включено (див. примітку)",
    PAYER_FORM_TITLE: "Платник премії",
    FILTER_CLEAR_SELECTION: "Скасувати вибір",
    PAYMENT_INTERVAL_CLEAR_SELECTION: "Скасувати вибір",
    PAYMENT_INTERVAL_REQUIRED: "Оберіть періодичність оплати.",
    PAYMENT_INTERVAL_TITLE: "Періодичність оплати",
    PAYMENT_INTERVAL_MONTHLY: "Щомісяця",
    PAYMENT_INTERVAL_QUARTERLY: "Щокварталу",
    PAYMENT_INTERVAL_SEMIANNUAL: "Раз на півроку",
    PAYMENT_INTERVAL_ANNUAL: "Щороку",
    PAYMENT_INTERVAL_ONCE: "Одноразово",
    PAYMENT_INTERVAL_WEEKLY: "Щотижня",
    PAYMENT_INTERVAL_DAILY: "Щодня",
    PAYMENT_INTERVAL_ANNUAL_TOTAL: "{price} / рік",
    PAYMENT_INTERVAL_SAVINGS: "Ви заощаджуєте {price} / рік",
    PAYMENT_INTERVAL_UNAVAILABLE: "Недоступно",
    PAYMENT_INTERVAL_UNAVAILABLE_TOOLTIP:
      "Ця періодичність оплати недоступна для розрахованого внеску — часто тому, що внесок нижчий за мінімальний для цього інтервалу. Оберіть один із доступних варіантів.",
    PAYMENT_INTERVAL_CHEAPEST_TOOLTIP:
      "Найнижча ціна для поточного вибраного продукту — серед доступних періодичностей оплати, показаних тут для цього продукту.",
    PAYMENT_METHOD: "Спосіб оплати",
    PAYMENT_SECTION: "Оплата",
    PLEASE_FILL_FIELD: "Заповніть це поле.",
    PLEASE_WAIT_CONTRACT_NUM: "Зачекайте, генерується номер заявки.",
    PREMIUM_CALC_ERROR_BODY_P1:
      "За наданими вами даними неможливо розрахувати очікувану страхову премію.",
    PREMIUM_CALC_ERROR_BODY_P2_PREFIX:
      "Спробуйте ще раз. Якщо помилка повторюється, зверніться до нашої служби підтримки за адресою ",
    PREMIUM_CALC_ERROR_BUTTON: "До результатів",
    PREMIUM_CALC_ERROR_TITLE: "Помилка розрахунку премії",
    PRICE: "Вартість",
    PRICE_ASC: "€",
    PRICE_ASC_MOBILE: "Найнижча вартість",
    PRICE_DESC: "€€€",
    PRICE_DESC_MOBILE: "Найвища вартість",
    PRICE_UPDATE_MODAL_ALERT_VARIANTS: {
      priceOnly: "Страхову премію перераховано.",
      contractOnlyToInquiry: "Цей продукт тепер доступний лише за запитом.",
      contractOnlyFromInquiry:
        "Цей продукт більше не потребує запиту, і його тепер можна оформити безпосередньо.",
      priceAndContractToInquiry:
        "Страхову премію перераховано, і цей продукт тепер доступний лише за запитом.",
      priceAndContractFromInquiry:
        "Страхову премію перераховано, і цей продукт тепер можна оформити безпосередньо.",
    },
    PRICE_UPDATE_MODAL_ALERT_UNAVAILABLE:
      "Цей продукт не можна оформити з вашими поточними даними.",
    PRICE_UPDATE_MODAL_CONFIRM_BUTTON: "Підтвердити нову премію",
    PRICE_UPDATE_MODAL_CONFIRM_BUTTON_CONTRACT: "Підтвердити зміни",
    PRICE_UPDATE_MODAL_IMPORTANT_LABEL: "Важливе повідомлення:",
    PRICE_UPDATE_MODAL_NEW_PREMIUM: "Нова вартість",
    PRICE_UPDATE_MODAL_OLD_PREMIUM: "Попередня вартість",
    PRICE_UPDATE_MODAL_RECALC_CONFIRM:
      "Підтвердіть нову премію, щоб продовжити.",
    PRICE_UPDATE_MODAL_RECALC_PREFIX:
      "За вашими даними страхову премію перераховано; тепер вона становить ",
    PRICE_UPDATE_MODAL_CONTRACT_MODEL_CHANGED_TO_INQUIRY:
      "На підставі ваших останніх даних цей продукт тепер доступний лише за запитом.",
    PRICE_UPDATE_MODAL_CONTRACT_MODEL_CONFIRM_TO_INQUIRY:
      "Будь ласка, підтвердьте зміни, щоб продовжити.",
    PRICE_UPDATE_MODAL_CONTRACT_MODEL_CHANGED_FROM_INQUIRY:
      "На підставі ваших останніх даних цей продукт більше не потребує запиту, і його тепер можна оформити безпосередньо.",
    PRICE_UPDATE_MODAL_CONTRACT_MODEL_CONFIRM_FROM_INQUIRY:
      "Будь ласка, підтвердьте зміни, щоб продовжити оформлення заявки.",
    PRICE_UPDATE_MODAL_SENTENCE_DOT: ".",
    PRICE_UPDATE_MODAL_BODY_VARIANTS: {
      empty: [],
      priceOnly: [
        "@:message.PRICE_UPDATE_MODAL_RECALC_PREFIX",
        "__PRICE__",
        "@:message.PRICE_UPDATE_MODAL_SENTENCE_DOT",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_RECALC_CONFIRM",
      ],
      contractOnlyToInquiry: [
        "@:message.PRICE_UPDATE_MODAL_CONTRACT_MODEL_CHANGED_TO_INQUIRY",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_CONTRACT_MODEL_CONFIRM_TO_INQUIRY",
      ],
      contractOnlyFromInquiry: [
        "@:message.PRICE_UPDATE_MODAL_CONTRACT_MODEL_CHANGED_FROM_INQUIRY",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_CONTRACT_MODEL_CONFIRM_FROM_INQUIRY",
      ],
      priceAndContractToInquiry: [
        "@:message.PRICE_UPDATE_MODAL_RECALC_PREFIX",
        "__PRICE__",
        "@:message.PRICE_UPDATE_MODAL_SENTENCE_DOT",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_CONTRACT_MODEL_CHANGED_TO_INQUIRY",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_RECALC_CONFIRM",
      ],
      priceAndContractFromInquiry: [
        "@:message.PRICE_UPDATE_MODAL_RECALC_PREFIX",
        "__PRICE__",
        "@:message.PRICE_UPDATE_MODAL_SENTENCE_DOT",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_CONTRACT_MODEL_CHANGED_FROM_INQUIRY",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_RECALC_CONFIRM",
      ],
    },
    PRICE_UPDATE_MODAL_TITLE_CHANGED: "Вашу премію змінено",
    PRICE_UPDATE_MODAL_TITLE_CONTRACT_CHANGED: "Статус заявки змінено",
    PRICE_UPDATE_MODAL_TITLE_UNAVAILABLE: "Цей продукт більше недоступний",
    PRICE_UPDATE_MODAL_UNAVAILABLE_BODY:
      "Через ваші останні введені дані цей продукт більше не відповідає правилам приймання страховика. Оформлення наразі неможливе.",
    PRINT: "Друкувати",
    PRINT_RESULTS: "Друкувати",
    PRINT_THIS_SITE: "Друкувати сторінку",
    PRODUCT_PROVIDER: "Постачальник продукту",
    REACH_US_TEXT: "Зв’яжіться з нами Пн–Пт, 9:00–17:00",
    REQUEST_OTP_LOCKED_ERROR_BODY:
      "Забагато невдалих спроб. Зачекайте ще {seconds} секунд, перш ніж запитувати новий одноразовий код.",
    REQUEST_OTP_RATE_LIMITED_ERROR_BODY:
      "Ви вже запросили одноразовий код. Зачекайте ще {seconds} секунд, перш ніж запитувати новий одноразовий код.",
    REQUEST_CODE: "Запросити одноразовий код",
    RESET_FILTERS: "Скинути фільтри",
    RESUME_BOOKING_LOADER_TITLE: "Ваша чернетка заявки готується",
    RESUME_BOOKING_LOADER_SUBTITLE:
      "Зачекайте, будь ласка, поки ми завантажимо вашу збережену чернетку заявки.",
    RESUME_BOOKING_LOADER_STEP_SESSION: "Завантажуємо дані",
    RESUME_BOOKING_LOADER_STEP_SEARCH_FORM: "Завантажуємо форму пошуку",
    RESUME_BOOKING_LOADER_STEP_TARIFFS: "Шукаємо тарифи",
    RESUME_BOOKING_LOADER_STEP_BOOKING_FORM: "Готуємо форму бронювання",
    RESUME_BOOKING_LOADER_ERROR_TITLE: "Не вдалося завершити цей крок",
    RESUME_BOOKING_LOADER_ERROR_SESSION_COMPLETED:
      "Це бронювання вже завершено. Тому посилання-запрошення більше не дійсне.",
    RESUME_BOOKING_LOADER_ERROR_SESSION:
      "Не вдалося завантажити збережену чернетку заявки.",
    RESUME_BOOKING_LOADER_ERROR_SEARCH_FORM:
      "Не вдалося завантажити форму пошуку. Спробуйте ще раз пізніше.",
    RESUME_BOOKING_LOADER_ERROR_TARIFFS:
      "Вибраний тариф більше недоступний. Також ви можете почати новий пошук тарифу.",
    RESUME_BOOKING_LOADER_ERROR_BOOKING_FORM:
      "Не вдалося завантажити форму бронювання. Спробуйте ще раз пізніше.",
    RESUME_BOOKING_LOADER_ERROR_GENERIC:
      "Під час відновлення бронювання сталася помилка. Спробуйте ще раз пізніше.",
    RESUME_BOOKING_LOADER_SEARCH_NEW_TARIFF_HINT:
      "Також ви можете почати новий пошук тарифу.",
    RESUME_BOOKING_LOADER_SEARCH_NEW_TARIFF_LINK: "Знайти новий тариф",
    RESUME_BOOKING_CONFIRM_KICKER: "Ваш чернетковий запит",
    RESUME_BOOKING_CONFIRM_TITLE_PREFIXED: "Чернетка заявки: {title}",
    RESUME_BOOKING_AUTH_ILLUSTRATION_TEXT:
      "Для захисту вашої чернетки заявки ми надішлемо код підтвердження електронною поштою.",
    RESUME_BOOKING_CONFIRM_REDIRECT_DESCRIPTION_GENERIC:
      "Код підтвердження буде надіслано електронною поштою. Будь ласка, зачекайте. Незабаром вас буде перенаправлено до введення коду.",
    RESUME_BOOKING_CONFIRM_DESCRIPTION:
      "Введіть адресу електронної пошти, пов’язану з цією чернеткою заявки. На цю адресу ми надішлемо одноразовий код для доступу до чернетки заявки.",
    RESUME_BOOKING_CONFIRM_EMAIL_LOADING_DESCRIPTION:
      "Ми перевіряємо, на яку адресу електронної пошти слід надіслати код підтвердження …",
    RESUME_BOOKING_CONFIRM_REDIRECT_DESCRIPTION:
      "Код підтвердження буде надіслано на адресу {email}.",
    RESUME_BOOKING_CONFIRM_CODE_PLACEHOLDER: "Код доступу",
    RESUME_BOOKING_LOADER_ERROR_SESSION_NOT_FOUND:
      "Збережену чернетку заявки не знайдено або її було видалено.",
    RESUME_BOOKING_LOADER_ERROR_SESSION_EXPIRED:
      "Термін дії цієї збереженої чернетки заявки минув.",
    RESUME_BOOKING_CONFIRM_EMAIL_HINT:
      "Одноразовий код буде надіслано на {email}",
    RESUME_BOOKING_VERIFY_TITLE: "Введіть одноразовий код",
    RESUME_BOOKING_VERIFY_DESCRIPTION:
      "Одноразовий код надіслано на адресу {email}. Перевірте електронну пошту та введіть 9-значний одноразовий код нижче.",
    RESUME_BOOKING_VERIFY_DESCRIPTION_PENDING:
      "Спочатку запросіть одноразовий код. Потім ви зможете ввести 9-значний одноразовий код тут.",
    RESUME_BOOKING_VERIFY_ERROR_TITLE: "Не вдалося підтвердити код",
    RESUME_BOOKING_VERIFY_ERROR_BODY:
      "Перевірте введений одноразовий код або запросіть новий одноразовий код.",
    RESUME_BOOKING_VERIFY_CODE_ARIA_LABEL: "9-значний код підтвердження",
    RESUME_BOOKING_VERIFY_BUTTON: "Підтвердити одноразовий код",
    RESUME_BOOKING_VERIFY_CODE_EXPIRY: "Одноразовий код дійсний ще {time}.",
    RESUME_BOOKING_VERIFY_RESEND_COUNTDOWN: "Надіслати повторно через {time}",
    RESUME_BOOKING_VERIFY_RESEND_QUESTION: "Не отримали одноразовий код?",
    RESUME_BOOKING_VERIFY_RESEND_BUTTON: "Надіслати новий одноразовий код.",
    VERIFY_OTP_BLANK_ERROR_BODY: "Введіть код підтвердження.",
    VERIFY_OTP_INVALID_ERROR_BODY:
      "Введений одноразовий код недійсний. Перевірте одноразовий код в електронній пошті та спробуйте ще раз.",
    VERIFY_OTP_INVALID_LOCKED_ERROR_BODY:
      "Забагато спроб. Спробуйте ще раз через {time}.",
    VERIFY_OTP_LOCKED_ERROR_BODY:
      "Забагато спроб. Спробуйте ще раз через {time}.",
    VERIFY_OTP_ALREADY_CONSUMED_ERROR_BODY:
      "Цей одноразовий код уже було використано. Запросіть новий одноразовий код.",
    VERIFY_OTP_NO_ACTIVE_OTP_ERROR_BODY:
      "Активний одноразовий код не знайдено. Запросіть новий одноразовий код.",
    VERIFY_OTP_RATE_LIMITED_ERROR_BODY:
      "Зачекайте ще {seconds} секунд, перш ніж запитувати новий одноразовий код.",
    VERIFY_OTP_EXPIRED_ERROR_BODY:
      "Термін дії введеного одноразового коду минув. Будь ласка, запросіть новий одноразовий код і спробуйте ще раз.",
    RISK_CARRIER: "Страховик-носій ризику",
    RISK_ZONE_COULD_NOT_BE_DETERMINED: "Не вдалося визначити зону ZÜRS.",
    SAVE: "Зберегти",
    FEATURE_HIGHLIGHT_SAVE_BUTTON_TITLE: "Зберегти чернетку",
    FEATURE_HIGHLIGHT_SAVE_BUTTON_BODY:
      "Збережіть заявку як чернетку. Усе, що потрібно, — адреса електронної пошти, на яку ми надішлемо персональне посилання на вашу заявку.",
    FEATURE_HIGHLIGHT_DISMISS: "Зрозуміло",
    FEATURE_HIGHLIGHT_NEXT: "Далі",
    FEATURE_HIGHLIGHT_STEP_OF: "Підказка {current} з {total}",
    FEATURE_HIGHLIGHT_SEARCH_INSURER_ROW_TITLE: "Порівняйте страховиків",
    FEATURE_HIGHLIGHT_SEARCH_INSURER_ROW_BODY:
      "Швидко фільтруйте результати за страховиком і переглядайте стартову ціну кожної компанії.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_TITLE: "Дії для тарифу",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY:
      "Тут доступні дії для тарифу: виберіть тариф для пропозиції, за бажанням додайте коментар, виберіть кілька тарифів для порівняння або роздрукуйте всі деталі потрібного тарифу.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY_MARK_COMPARE:
      "Тут доступні дії для тарифу: виберіть тариф для пропозиції, за бажанням додайте коментар і виберіть кілька тарифів для порівняння.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY_MARK_PRINT:
      "Тут доступні дії для тарифу: виберіть тариф для пропозиції, за бажанням додайте коментар або роздрукуйте всі деталі потрібного тарифу.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY_MARK:
      "Тут доступні дії для тарифу: виберіть тариф для пропозиції та за бажанням додайте коментар.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY_COMPARE_PRINT:
      "Тут доступні дії для тарифу: виберіть кілька тарифів для порівняння або роздрукуйте всі деталі потрібного тарифу.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY_COMPARE:
      "Тут доступні дії для тарифу: виберіть кілька тарифів для порівняння.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY_PRINT:
      "Тут доступні дії для тарифу: роздрукуйте всі деталі потрібного тарифу.",
    FEATURE_HIGHLIGHT_SEARCH_PAYMENT_FOOTER_TITLE: "Способи оплати внизу",
    FEATURE_HIGHLIGHT_SEARCH_PAYMENT_FOOTER_BODY:
      "Способи оплати тепер у нижній панелі картки тарифу. Натисніть «Способи оплати», щоб побачити всі інтервали з річним внеском і найдешевшою ціною за способом оплати.",
    FEATURE_HIGHLIGHT_SEARCH_VIEW_MENU_TITLE: "Налаштуйте вигляд",
    FEATURE_HIGHLIGHT_SEARCH_VIEW_MENU_BODY:
      "Змінюйте тему, контраст і розмір шрифту через меню «Вигляд».",
    FEATURE_HIGHLIGHT_DOCUMENTS_ZIP_TITLE: "Усі документи одразу",
    FEATURE_HIGHLIGHT_DOCUMENTS_ZIP_BODY:
      "Завантажте всі документи вашої заявки одним ZIP-файлом.",
    FEATURE_HIGHLIGHT_MOBILE_UPLOAD_TITLE: "Новинка: завантаження зі смартфона",
    FEATURE_HIGHLIGHT_MOBILE_UPLOAD_BODY:
      "Скануйте QR-код і завантажте документи зі смартфона — без додаткового входу.",
    SAVE_AND_SEND: "Зберегти й надіслати",
    SAVE_NOW: "Зберегти зараз",
    SAVED_SESSION: "Сесію збережено. Посилання для продовження: {resumeUrl}",
    SAVE_SESSION_COMPLETED_COPIED: "Посилання скопійовано",
    SAVE_SESSION_COMPLETED_COPY_LINK: "Скопіювати посилання",
    SAVE_SESSION_COMPLETED_EMAIL_SENT: "Підтвердження надіслано на {email}",
    SAVE_SESSION_COMPLETED_LINK_LABEL: "Посилання на чернетку заявки",
    SAVE_SESSION_COMPLETED_TITLE: "Успішно збережено",
    SAVE_SESSION_DEFAULT_TITLE: "Моє страхування {appName}",
    SAVE_SESSION_EMAILS: "Електронні адреси",
    SAVE_SESSION_EMAIL_PLACEHOLDER: "Введіть іншу електронну адресу …",
    SAVE_SESSION_INACTIVITY_DISCLAIMER:
      "Збережені чернетки заявок автоматично видаляються після 30 днів неактивності.",
    SAVE_SESSION_INSURER_FALLBACK: "страховик",
    SAVE_SESSION_NOT_TRANSMITTED:
      "Заявку ще не передано відповідальному страховику.",
    SAVE_SESSION_DRAFT_DISCLAIMER:
      "<strong>Зверніть увагу:</strong> Це збережена чернетка страхової заявки. Юридично обов’язкова заявка виникає лише тоді, коли ви надсилаєте її кнопкою «{submitButton}». Збереження не створює договірних відносин. Страховий захист існує лише після того, як <strong>{insurerName}</strong> прямо прийме вашу заявку.",
    SAVE_SESSION_SHARE_WITH_BROKER_HELPER:
      "Зазначений посередник отримає доступ до цієї збереженої вами чернетки заявки. Ви можете будь-коли знову вимкнути цю опцію.",
    SAVE_SESSION_SHARE_WITH_BROKER:
      "Дозволити {brokerName} доступ до моєї збереженої чернетки заявки",
    SAVE_SESSION_NOTE: "Примітка",
    SAVE_SESSION_NOTE_ADD: "Розширені налаштування",
    SAVE_SESSION_NOTE_PLACEHOLDER: "Особисте повідомлення для отримувачів …",
    SAVE_SESSION_NOTIFY_PARTICIPANTS_LABEL:
      "Повідомити інших учасників про зміни",
    SAVE_SESSION_NOTIFY_PARTICIPANTS_QUESTION:
      "Бажаєте повідомити інших учасників про ваші зміни?",
    SAVE_SESSION_NOTIFY_SEND: "Надіслати",
    SAVE_SESSION_NOTIFY_NOW: "Повідомити зараз",
    SAVE_SESSION_NOTIFY_SENT_LABEL: "Повідомлено",
    SAVE_SESSION_PARTICIPANT_EMAIL_SUCCESS_TITLE: "Електронний лист надіслано",
    SAVE_SESSION_PARTICIPANT_EMAIL_SUCCESS_BODY:
      "Електронний лист було надіслано всім особам, а бронювання збережено.",
    SAVE_SESSION_PARTICIPANT_EMAIL_ERROR_TITLE:
      "Не вдалося надіслати електронний лист",
    SAVE_SESSION_PARTICIPANT_EMAIL_ERROR_BODY:
      "Не вдалося зберегти бронювання або повідомити учасників. Спробуйте ще раз.",
    SAVE_SESSION_PARTICIPANTS_NOTIFIED_SUCCESS:
      "Учасників повідомлено електронною поштою.",
    SAVE_SESSION_PARTICIPANTS_NOTIFIED_ERROR:
      "Зміни збережено, але повідомити учасників не вдалося.",
    SAVE_SESSION_PARTICIPANTS: "Учасники",
    SAVE_SESSION_INVITE_PEOPLE: "Запросити осіб",
    SAVE_SESSION_INVITE_BUTTON: "Запросити",
    SAVE_SESSION_ADD_ANOTHER_PERSON: "додати ще одну особу",
    SAVE_SESSION_SEND_INVITATION: "Надіслати запрошення",
    SAVE_SESSION_NEW_INTRO:
      "Збережіть заявку як чернетку. Усе, що потрібно, — адреса електронної пошти, на яку ми надішлемо персональне посилання.",
    SAVE_SESSION_NEW_INTRO_BROKER:
      "Збережіть заявку як чернетку. Введіть назву — чернетка з’явиться у вашому огляді чернеток у порталі для партнерів.",
    SAVE_SESSION_NEW_INTRO_WITH_SHARING:
      "Збережіть заявку як чернетку. Усе, що потрібно, — адреса електронної пошти, на яку ми надішлемо персональне посилання. Після цього ви також можете запросити інших осіб до своєї заявки.",
    SAVE_SESSION_EDIT_TITLE: "Редагувати назву",
    SAVE_SESSION_EDIT_NOTE: "Редагувати примітку",
    SAVE_SESSION_PARTICIPANTS_INTRO:
      "Додайте інших людей, які матимуть доступ до цього бронювання — наприклад друзів, родину, брокера або клієнтів. Кожну адресу електронної пошти можна використати лише один раз. Це не список застрахованих осіб.",
    SAVE_SESSION_NO_PARTICIPANTS: "Ще не додано осіб.",
    SAVE_SESSION_PARTICIPANT_TITLE: "Учасник/-ця {number}",
    SAVE_SESSION_REMOVE_PARTICIPANT: "Видалити учасника/-цю {number}",
    SAVE_SESSION_PARTICIPANT_STATUS_PENDING: "Очікує",
    SAVE_SESSION_PARTICIPANT_STATUS_INVITED: "Запрошено",
    SAVE_SESSION_PARTICIPANT_STATUS_ACCEPTED: "Прийнято",
    SAVE_SESSION_PARTICIPANT_STATUS_OPENED: "Відкрито",
    SAVE_SESSION_PARTICIPANT_LAST_OPENED: "Востаннє відкрито: {date}",
    SAVE_SESSION_PARTICIPANT_STATUS_OWNER: "Власник",
    SAVE_SESSION_PARTICIPANT_ACCEPTED_AT: "Прийнято: {date}",
    SAVE_SESSION_EDIT_PARTICIPANT: "Редагувати учасника/-цю {number}",
    SAVE_SESSION_DONE: "Готово",
    SAVE_SESSION_PARTICIPANTS_HELPER:
      "Усі учасники отримають посилання електронною поштою та зможуть відкрити чернетку заявки.",
    SAVE_SESSION_PARTICIPANTS_HINT:
      "(електронні адреси, одна в рядку або через кому)",
    SAVE_SESSION_TITLE: "Назва",
    SAVE_SESSION_TITLE_REQUIRED: "Будь ласка, введіть назву.",
    SAVE_SESSION_EMAIL_REQUIRED:
      "Будь ласка, введіть адресу електронної пошти.",
    SAVE_SESSION_MANAGE_DESCRIPTION:
      "Щоб керувати учасниками, дозволами або посиланнями доступу, відкрийте керування чернеткою заявки.",
    SAVE_SESSION_MANAGE_TITLE: "Керувати чернеткою",
    SAVE_SESSION_SHARE_TITLE: "Поділитися чернеткою",
    SAVE_SESSION_SHARE_MENU_SHARE: "Поділитися чернеткою",
    SAVE_SESSION_SHARE_MENU_EDIT_CALCULATION: "Редагувати чернетку",
    SAVE_SESSION_SHARE_MENU_MANAGE_ACCESS: "Керувати доступом",
    SAVE_SESSION_EDIT_CALCULATION_TITLE: "Редагувати чернетку",
    SAVE_SESSION_EDIT_CALCULATION_INTRO:
      "Змініть назву та примітку збереженої чернетки заявки.",
    SAVE_SESSION_MANAGE_ACCESS_TITLE: "Керувати доступом",
    SAVE_SESSION_MANAGE_ACCESS_INTRO:
      "Тут можна змінювати імена та права доступу, а також додавати чи видаляти осіб. Кожну адресу електронної пошти можна використати лише один раз — зокрема адресу власника повторно запросити не можна. Після запрошення адреси змінити неможливо; за потреби видаліть особу та запросіть знову.",
    SAVE_SESSION_EMAIL_ALREADY_USED:
      "Ця адреса електронної пошти вже використовується.",
    SAVE_SESSION_SAVE_TITLE: "Зберегти чернетку",
    SAVE_SESSION_TITLE_HELPER: "Запропоновано автоматично — можна редагувати",
    SAVE_SESSION_UPDATE_OWNER_LINK: "Посилання власника на чернетку заявки",
    SAVE_SESSION_UPDATE_OWNER_LINK_HELPER:
      "За цим посиланням власник може безпосередньо відкрити чернетку заявки і керувати нею.",
    SAVE_SESSION_UPDATE_GENERAL_LINK: "Загальне посилання на чернетку заявки",
    SAVE_SESSION_UPDATE_GENERAL_LINK_HELPER:
      "Введіть адресу електронної пошти, збережену в цій чернетці заявки. Ми надішлемо лист на цю адресу — відкрийте чернетку заявки за посиланням у листі.",
    SAVE_SESSION_UPDATE_SUCCESS_TITLE: "Чернетку заявки успішно збережено",
    SAVE_SESSION_UPDATE_SUCCESS_EMAIL_SENT:
      "Посилання на чернетку заявки надіслано на {emails}.",
    SAVE_SESSION_EMAIL_LIST_AND: "та",
    SAVE_SESSION_UPDATE_SUCCESS_SAVED: "Чернетку заявки збережено.",
    SAVE_SESSION_UPDATE_SUCCESS_INVITE_HINT:
      "За потреби запросіть зараз інших осіб.",
    SAVE_SESSION_SUCCESS_EMAIL_SENT_LINE:
      "Посилання на чернетку заявки надіслано на {email}.",
    SAVE_SESSION_SUCCESS_PORTAL_DRAFTS_LINE:
      "Вашу чернетку можна знайти в порталі для партнерів у розділі {portalDraftsLink}. Посилання на чернетку надіслано на {email}.",
    SAVE_SESSION_SUCCESS_PORTAL_DRAFTS_NAV: "Заявки > Чернетки",
    SAVE_SESSION_SUCCESS_CHECK_EMAIL:
      "Посилання на вашу чернетку заявки надійде протягом кількох хвилин. Перевірте електронну пошту та за потреби папку «Спам».",
    SAVE_SESSION_SUCCESS_SHARE: "Поділитися чернеткою",
    SAVE_SESSION_SUCCESS_INVITE_MORE: "Запросити інших осіб",
    SAVE_SESSION_SUCCESS_INVITE_MORE_SHORT: "Запросити осіб",
    SAVE_SESSION_SUCCESS_SHARE_DISABLED_HINT:
      "Поділитися можна після відкриття посилання з електронного листа.",
    SAVE_SESSION_SUCCESS_CONTINUE: "Продовжити заявку",
    SAVE_SESSION_SUCCESS_CONTINUE_SHORT: "Продовжити",
    SAVE_SESSION_UPDATE_PARTICIPANTS: "Учасники",
    SAVE_SESSION_UPDATE_PERSONALIZED_LINK: "Персоналізоване посилання",
    SAVE_SESSION_UPDATE_PERSONALIZED_LINK_TOOLTIP:
      "Адресу електронної пошти вже збережено — при відкритті її не потрібно вводити знову.",
    SAVE_SESSION_UPDATE_RECOMMENDED: "рекомендовано",
    SAVE_SESSION_OWNER: "Власник бронювання",
    SAVE_SESSION_OWNER_INTRO:
      "Ви — власник бронювання. Ви можете переглядати, редагувати та надсилати це бронювання й отримаєте збережений розрахунок електронною поштою.",
    SAVE_SESSION_OWNER_EMAIL: "Електронна пошта власника бронювання",
    SAVE_SESSION_OWNER_EMAIL_LABEL: "Електронна пошта",
    SAVE_SESSION_OWNER_EMAIL_HELPER:
      "Потрібно для збереження. Посилання на чернетку заявки ви отримаєте автоматично електронною поштою.",
    SAVE_SESSION_OWNER_NAME: "Ім’я власника бронювання",
    SAVE_SESSION_ADD_PARTICIPANT: "Додати учасника/-цю",
    SAVE_SESSION_PARTICIPANT_DATE_TIME: "{date} о {time}",
    SAVE_SESSION_AUTO_TITLE_VALUE_INSURANCE: "{appName} для {value}",
    SAVE_SESSION_PERMISSION: "Дозвіл",
    SAVE_SESSION_PARTICIPANT_EMAIL_PLACEHOLDER: "електронна пошта",
    SAVE_SESSION_PARTICIPANT_NAME_PLACEHOLDER: "ім’я",
    SAVE_SESSION_NAME_LABEL: "Ім’я",
    SAVE_SESSION_NAME_EXAMPLE_PLACEHOLDER: "напр. Макс",
    SAVE_SESSION_PERMISSION_VIEW: "Перегляд",
    SAVE_SESSION_PERMISSION_VIEW_EDIT: "Перегляд + Редагування",
    SAVE_SESSION_PERMISSION_VIEW_EDIT_SUBMIT:
      "Перегляд + Редагування + Відправлення",
    INVITATIO_RESUME_BOOKING_CONFIRM_KICKER: "Ваша чернетка запиту",
    INVITATIO_RESUME_BOOKING_CONFIRM_TITLE_PREFIXED: "Чернетка запиту: {title}",
    INVITATIO_RESUME_BOOKING_AUTH_ILLUSTRATION_TEXT:
      "Для захисту вашої чернетки запиту ми надішлемо код підтвердження електронною поштою.",
    INVITATIO_RESUME_BOOKING_CONFIRM_DESCRIPTION:
      "Введіть адресу електронної пошти, пов’язану з цією чернеткою запиту. На цю адресу ми надішлемо одноразовий код для доступу до чернетки запиту.",
    INVITATIO_RESUME_BOOKING_LOADER_ERROR_SESSION:
      "Збережену чернетку запиту не вдалося завантажити.",
    INVITATIO_RESUME_BOOKING_LOADER_ERROR_SESSION_NOT_FOUND:
      "Збережену чернетку запиту не знайдено або її було видалено.",
    INVITATIO_RESUME_BOOKING_LOADER_ERROR_SESSION_EXPIRED:
      "Термін дії цієї збереженої чернетки запиту минув.",
    INVITATIO_RESUME_BOOKING_LOADER_TITLE: "Ваша чернетка запиту готується",
    INVITATIO_RESUME_BOOKING_LOADER_SUBTITLE:
      "Будь ласка, зачекайте, поки ми завантажимо вашу збережену чернетку запиту.",
    INVITATIO_SAVE_SESSION_COMPLETED_LINK_LABEL: "Посилання на чернетку запиту",
    INVITATIO_SAVE_SESSION_INACTIVITY_DISCLAIMER:
      "Збережені чернетки запитів автоматично видаляються після 30 днів неактивності.",
    INVITATIO_SAVE_SESSION_NOT_TRANSMITTED:
      "Запит ще не передано відповідальному страховику.",
    INVITATIO_SAVE_SESSION_DRAFT_DISCLAIMER:
      "<strong>Зверніть увагу:</strong> Це збережена чернетка страхового запиту. Юридично обов’язковий запит виникає лише тоді, коли ви надсилаєте його кнопкою «{submitButton}». Збереження не створює договірних відносин. Страховий захист існує лише після того, як <strong>{insurerName}</strong> прямо прийме ваш запит.",
    INVITATIO_SAVE_SESSION_SHARE_WITH_BROKER:
      "Дозволити {brokerName} доступ до моєї збереженої чернетки запиту",
    INVITATIO_SAVE_SESSION_NEW_INTRO:
      "Збережіть запит як чернетку. Усе, що потрібно, — адреса електронної пошти, на яку ми надішлемо персональне посилання.",
    INVITATIO_SAVE_SESSION_NEW_INTRO_BROKER:
      "Збережіть запит як чернетку. Введіть назву — чернетка з’явиться у вашому огляді чернеток у порталі для партнерів.",
    INVITATIO_SAVE_SESSION_NEW_INTRO_WITH_SHARING:
      "Збережіть запит як чернетку. Усе, що потрібно, — адреса електронної пошти, на яку ми надішлемо персональне посилання. Після цього ви також можете запросити інших осіб до своєї чернетки запиту.",
    INVITATIO_SAVE_SESSION_PARTICIPANTS_INTRO:
      "Запросіть інших осіб, щоб вони могли переглядати, редагувати або надсилати ваш запит як чернетку. Кожну адресу електронної пошти можна використати лише один раз.",
    INVITATIO_SAVE_SESSION_PARTICIPANTS_HELPER:
      "Усі учасники отримають посилання електронною поштою та зможуть відкрити запит як чернетку.",
    INVITATIO_SAVE_SESSION_SHARE_WITH_BROKER_HELPER:
      "Зазначений посередник отримає доступ до цієї збереженої вами чернетки запиту. Ви можете будь-коли знову вимкнути цю опцію.",
    INVITATIO_SAVE_SESSION_MANAGE_DESCRIPTION:
      "Щоб керувати учасниками, дозволами або посиланнями доступу, відкрийте керування запитом як чернеткою.",
    INVITATIO_SAVE_SESSION_MANAGE_TITLE: "Керувати чернеткою",
    INVITATIO_SAVE_SESSION_SHARE_TITLE: "Поділитися чернеткою",
    INVITATIO_SAVE_SESSION_SHARE_MENU_SHARE: "Поділитися чернеткою запиту",
    INVITATIO_SAVE_SESSION_SHARE_MENU_EDIT_CALCULATION:
      "Редагувати чернетку запиту",
    INVITATIO_SAVE_SESSION_EDIT_CALCULATION_TITLE: "Редагувати чернетку",
    INVITATIO_SAVE_SESSION_EDIT_CALCULATION_INTRO:
      "Змініть назву та примітку збереженої чернетки запиту.",
    INVITATIO_SAVE_SESSION_SAVE_TITLE: "Зберегти чернетку",
    INVITATIO_SAVE_SESSION_TITLE_HELPER:
      "Оберіть зручну назву для чернетки запиту або скористайтеся запропонованою. Назву можна змінити пізніше.",
    INVITATIO_SAVE_SESSION_UPDATE_OWNER_LINK:
      "Посилання власника на чернетку запиту",
    INVITATIO_SAVE_SESSION_UPDATE_OWNER_LINK_HELPER:
      "За цим посиланням власник може безпосередньо відкрити чернетку запиту і керувати нею.",
    INVITATIO_SAVE_SESSION_UPDATE_GENERAL_LINK:
      "Загальне посилання на чернетку запиту",
    INVITATIO_SAVE_SESSION_UPDATE_GENERAL_LINK_HELPER:
      "Введіть адресу електронної пошти, збережену в цій чернетці запиту. Ми надішлемо лист на цю адресу — відкрийте чернетку запиту за посиланням у листі.",
    INVITATIO_SAVE_SESSION_UPDATE_SUCCESS_TITLE:
      "Чернетку запиту успішно збережено",
    INVITATIO_SAVE_SESSION_UPDATE_SUCCESS_EMAIL_SENT:
      "Посилання на чернетку запиту надіслано на {emails}.",
    INVITATIO_SAVE_SESSION_UPDATE_SUCCESS_SAVED: "Чернетку запиту збережено.",
    INVITATIO_SAVE_SESSION_SUCCESS_EMAIL_SENT_LINE:
      "Посилання на чернетку запиту надіслано на {email}.",
    INVITATIO_SAVE_SESSION_SUCCESS_PORTAL_DRAFTS_LINE:
      "Вашу чернетку запиту можна знайти в порталі для партнерів у розділі {portalDraftsLink}. Посилання на чернетку надіслано на {email}.",
    INVITATIO_SAVE_SESSION_SUCCESS_CHECK_EMAIL:
      "Посилання на вашу чернетку запиту надійде протягом кількох хвилин. Перевірте електронну пошту та за потреби папку «Спам».",
    INVITATIO_SAVE_SESSION_SUCCESS_SHARE: "Поділитися чернеткою запиту",
    INVITATIO_SAVE_SESSION_SUCCESS_SHARE_DISABLED_HINT:
      "Поділитися чернеткою запиту можна після відкриття посилання з електронного листа до вашої чернетки запиту.",
    INVITATIO_SAVE_SESSION_SUCCESS_CONTINUE: "Продовжити запит",
    INVITATIO_SAVE_SESSION_UPDATE_PERSONALIZED_LINK_TOOLTIP:
      "Адресу електронної пошти вже збережено — при відкритті чернетки запиту її не потрібно вводити знову.",
    INVITATIO_SAVE_SESSION_OWNER_INTRO:
      "Ви — власник цієї чернетки запиту. Ви можете переглядати, редагувати та надсилати цю чернетку запиту й отримаєте посилання електронною поштою.",
    INVITATIO_SAVE_SESSION_OWNER_EMAIL_HELPER:
      "Потрібно для збереження. Посилання на чернетку запиту ви отримаєте автоматично електронною поштою.",
    INVITATIO_FEATURE_HIGHLIGHT_SAVE_BUTTON_TITLE: "Зберегти чернетку запиту",
    INVITATIO_FEATURE_HIGHLIGHT_SAVE_BUTTON_BODY:
      "Збережіть запит як чернетку. Усе, що потрібно, — адреса електронної пошти, на яку ми надішлемо персональне посилання на вашу чернетку запиту.",
    INVITATIO_UPDATE_SESSION_ERROR_DESCRIPTION:
      "Не вдалося оновити чернетку запиту. Спробуйте ще раз.",

    SEALS_HEADING_INSURER: "Нагороди для цього страховика",
    SEALS_HEADING_PRODUCT: "Нагороди для цього продукту",
    SEALS_INDICATOR_LINK: "Нагороди ({count})",
    SEALS_MORE_LINK: "+ ще {count} …",
    SEARCHING_MATCHING_TARIFFS: "Підбираємо відповідні продукти …",
    SEARCH_FORM_LOADING: "Завантаження форми пошуку …",
    SEARCH_MASK_DISMISS_BTN_SHORT_TXT: "Змінити",
    SEARCH_MASK_DISMISS_BTN_TXT: "Змінити пошук",
    SEARCH_MASK_DISMISS_SECONDARY_BTN_SHORT_TXT: "Далі",
    SEARCH_MASK_DISMISS_SECONDARY_BTN_TXT: "Продовжити з налаштуваннями",
    SEARCH_MASK_ERROR: "Пошук не дав результатів. Заповніть усі поля.",
    SEARCH_MASK_MODAL_TEXT_PART_ONE: "Ви ще не змінювали критерії пошуку.",
    SEARCH_MASK_MODAL_TEXT_PART_TWO:
      "Можете залишити типові критерії або змінити пошук під свої потреби.",
    SEARCH_OFFERS: "Шукати продукти",
    SEARCH_RESULTS_APPLIED_LABEL: "Застосовані критерії пошуку",
    SEARCH_RESULTS_PRINT_GENERATED: "Створено: {date}",
    SEARCH_RESULTS_PRINT_QR_ALT:
      "QR-код із посиланням на це порівняння (як у листі електронної пошти)",
    SEARCH_RESULTS_PRINT_QR_HINT: "Посилання на сторінку",
    SHARE: "Поділитися",
    TARIFF_PRINT_TITLE: "Тариф: {id} – {name}",
    TARIFF_PRINT_PREPARING: "Підготовка до друку…",
    SEARCH_RESULTS_PRINT_TITLE: "Результати пошуку",
    SEND: "Надіслати",
    SEND_EMAIL_INFO_BOLD:
      "Надішліть це порівняння електронною поштою — безпосередньо клієнту або колезі.",

    SEND_EMAIL_INFO:
      "Адреси отримувачів не зберігаються та не передаються третім особам.",
    SEND_VIA_EMAIL: "Надіслати електронною поштою",
    SEND_VIA_EMAIL_SHORT: "Надіслати",
    SEPA_ERROR_MESSAGE: "Потрібна авторизація SEPA direct debit",
    SHARE_COMPARISON_EMAIL_ERROR_BODY:
      "Перевірте адресу електронної пошти або спробуйте пізніше.",
    SHARE_COMPARISON_EMAIL_ERROR_TITLE: "Сталася помилка",
    SHARE_COMPARISON_EMAIL_SUCCESS_BODY: "Посилання надіслано на {email}.",
    SHARE_COMPARISON_EMAIL_SUCCESS_TITLE: "Лист надіслано",
    SHARE_COMPARISON_MODAL_TITLE: "Поділитися порівнянням",
    SHOW_ALL_COUNT: "Показати всі {count}",
    SHOW_LESS: "Показати менше",
    SHOW_MORE_TARIFFS: "Показати більше результатів",
    SKIP_TO_CONTENT: "Перейти до основного вмісту",
    HEADER_NAV_LABEL: "Головна навігація",
    SORT: "Сортування",
    SORT_BY: "Сортувати за:",
    PRODUCTS_FOUND:
      "{count} продукт знайдено | {count} продукти знайдено | {count} продуктів знайдено",
    PRODUCTS_FOUND_NONE: "Продуктів не знайдено",
    SORT_TOGGLE_INSURER_HIGH: "Я",
    SORT_TOGGLE_INSURER_LOW: "А",
    SPECIAL_CONDITIONS_TEXT: "Ознайомтеся з особливими умовами",
    SPECIAL_FEATURES_AND_DEFINATIONS: "Особливі положення та визначення",
    SPECIAL_FEATURES_TOOLTIP:
      "У розділі «Примітки» — важлива інформація про продукт і договір, яка не входить до детального порівняння.",
    TARIFF_ADDONS: "Додаткові опції",
    TARIFF_ADDONS_INTRO_TEXT:
      "Для цього продукту доступні додаткові переваги. Їх можна додати в анкеті заявки. Додавання може змінити розраховану премію.",
    TARIFF_ADDONS_OVERVIEW_HEADING: "Обрані додаткові опції",
    TARIFF_BLOCK_BOOK_INQUIRY: "Запитати зараз",
    TARIFF_BLOCK_BOOK_INQUIRY_SHORT: "Запитати",
    TARIFF_BLOCK_COVOMO_PLAN_SCORE: "Оцінка продукту",
    TARIFF_BLOCK_COVOMO_RATING_GRADE: "Задовільно",
    TARIFF_BLOCK_MODAL_NOTICE_TITLE: "Примітка",
    TARIFF_BLOCK_PAYMENT_HEADING: "Варіанти оплати",
    TARIFF_BLOCK_PAYMENT_INTRO:
      "Для обраного продукту доступні такі способи оплати. Остаточний вибір способу оплати відбувається на останньому кроці анкети заявки.",
    TARIFF_BLOCK_PAYMENT_OPTIONS_LOADING: "Завантаження способів оплати …",
    TARIFF_BLOCK_PRICE_ON_REQUEST: "За запитом",
    TARIFF_BLOCK_REQUEST_QUOTE: "Запитати пропозицію",
    TARIFF_BLOCK_SUBJECT_INQUIRY_BADGE: "Потрібен запит",
    TARIFF_BLOCK_SUBJECT_INQUIRY_TOOLTIP:
      "Страховик розглядає цю заявку індивідуально. Може знадобитися час на рішення.",
    TARIFF_CARD_FOOTER_ADDONS: "Опції",
    TARIFF_CARD_FOOTER_COMPARE: "Порівняти",
    TARIFF_CARD_FOOTER_DETAILS: "Деталі",
    TARIFF_CARD_FOOTER_NOTES: "Примітки",
    TARIFF_CARD_FOOTER_PAYMENT: "Оплата",
    TARIFF_COMPARISON_SHOW_DIFFERENCES_ONLY: "Лише відмінності",
    TARIFF_COMPARISON_SHOW_PAYMENT_OPTIONS:
      "Показувати можливі інтервали оплати",
    TARIFF_COMPARISON_SHOW_TOOLTIPS_INLINE:
      "Показувати тексти підказок у порівнянні",
    TARIFF_COMPARISON_LOADING: "Ваше порівняння завантажується …",
    TARIFF_DETAILS: "Деталі продукту",
    TARIFF_MANAGER_BRAND_RATING: "{brandName} Оцінка: {score}",
    TARIFF_MANAGER_HOVER_SHOW_DETAILS: "Показати деталі",
    TARIFF_MANAGER_LEGACY_ID: "ID: {id}",
    TARIFF_RIBBON_CHEAPEST_PRICE: "Найнижча ціна",
    TAX_INCLUDED: "Вкл. податок на страхові премії",
    THE_FORMAT_OF: "Формат",
    TIP: "Примітки",
    TIP_SHOW: "Показати примітки",
    TOTAL_PRICE: "Загальна вартість",
    TO_COMPARE: "Порівняти продукти",
    TRAVELING_PEOPLE: "Вік мандрівників",
    TYPES_OF_INSURANCE: "Види покриття",
    USEFUL_LINKS: "Корисні посилання",
    BOOKING_LINK_COUNTRY_LABEL: "Країна",
    BOOKING_LINK_COUNTRY_D: "Німеччина",
    BOOKING_LINK_COUNTRY_AT: "Австрія",
    BOOKING_LINK_COUNTRY_CH: "Швейцарія",
    VERIFICATION_ALREADY_VERIFIED_P1:
      "Вашу електронну адресу вже підтверджено. Страхову заявку з номером <strong>{bookingId}</strong> успішно прийнято.",
    VERIFICATION_ALREADY_VERIFIED_P2:
      'Якщо ви ще не отримали підтвердження електронною поштою, перевірте «Спам» або зв’яжіться з підтримкою: <a href="mailto:{supportEmail}">{supportEmail}</a>.',
    VERIFICATION_ALREADY_VERIFIED_TITLE: "Електронну адресу вже підтверджено",
    VERIFICATION_BOOKING_PENDING_BODY:
      "Щоб ми переслали вашу заявку з номером <strong>{bookingData}</strong> до <strong>{insurerName}</strong>, натисніть посилання <strong>«Підтвердити електронну адресу»</strong> у листі, який щойно надіслано на <strong>{email}</strong>. Якщо листа немає, перевірте «Спам».",
    VERIFICATION_BOOKING_PENDING_FORWARD_NOTE:
      "Ми перешлемо заявку на страхування лише після успішного підтвердження.",
    VERIFICATION_BOOKING_PENDING_TITLE: "Підтвердіть електронну адресу",
    VERIFICATION_CONTACT_SUPPORT_DIRECT:
      'Зв’яжіться з підтримкою: <a href="mailto:{supportEmail}">{supportEmail}</a>.',
    VERIFICATION_CONTACT_SUPPORT_FOLLOWUP:
      'Якщо помилка повторюється, зв’яжіться з підтримкою: <a href="mailto:{supportEmail}">{supportEmail}</a>.',
    VERIFICATION_EMAIL_CONFIRM_EXPIRED_BODY:
      "Посилання для підтвердження заявки з номером <strong>{bookingId}</strong> більше не дійсне. Ми не оброблятимемо заявку на страхування далі.",
    VERIFICATION_EMAIL_CONFIRM_LINK_UNKNOWN:
      "Це посилання підтвердження електронної пошти нам невідоме. Перевірте, чи коректно його відкрито або скопійовано.",
    VERIFICATION_LINK_EXPIRED_TITLE: "Посилання більше не дійсне",
    VERIFICATION_LINK_EXPIRY_NOTICE:
      "<strong>Посилання дійсне лише до {date} 23:59.</strong>",
    VERIFICATION_LINK_INVALID_TITLE: "Посилання недійсне",
    VERIFICATION_RENEWAL_LINK_UNKNOWN:
      "Посилання на поновлення договору нам невідоме або воно більше не дійсне. Перевірте, чи коректно його відкрито або скопійовано.",
    VERIFICATION_RELOAD_PAGE: "Перезавантажити сторінку",
    VERIFICATION_SERVICE_UNAVAILABLE_BODY:
      "Цей сервіс зараз недоступний. Перезавантажте сторінку. Якщо проблема не зникне, спробуйте пізніше.",
    VERIFICATION_SERVICE_UNAVAILABLE_TITLE:
      "Підтвердження тимчасово недоступне",
    VERIFICATION_PRICE_UNAVAILABLE_BODY:
      "Новий внесок не вдалося визначити, бо дані вашої заявки застаріли і потребують оновлення.",
    VERIFICATION_LOADING: "Перевіряємо ваше підтвердження …",
    VERIFICATION_POLICY_START_CHANGED_TITLE:
      "Дату початку страхування та внесок змінено",
    VERIFICATION_POLICY_START_CHANGED_BODY:
      "Обрана раніше дата початку страхування більше недоступна для цього тарифу. Вашу заявку можна продовжити лише з новою датою початку та оновленим внеском.",
    VERIFICATION_POLICY_START_CHANGED_NOTE:
      "Заявку буде оброблено далі лише після вашого підтвердження.",
    VERIFICATION_POLICY_START_OLD_LABEL: "Попередня дата початку",
    VERIFICATION_POLICY_START_NEW_LABEL: "Нова дата початку",
    VERIFICATION_POLICY_START_OLD_PRICE_LABEL: "Попередній внесок",
    VERIFICATION_POLICY_START_NEW_PRICE_LABEL: "Новий внесок",
    VERIFICATION_POLICY_START_CONFIRM_BUTTON:
      "Підтвердити нову дату початку та внесок",
    VERIFICATION_POLICY_START_BOOKING_LABEL: "Номер заявки: ",
    VERIFICATION_SUCCESS_COVER_NOTICE:
      "<strong>Зверніть увагу:</strong> захист існує лише після прийняття та підтвердження вашої заявки на страхування компанією <strong>{insurerName}</strong>. Застосовується лише покриття згідно з умовами. Відображені переваги оновлюються наскільки можливо точно; для вашого договору вирішальним є обсяг покриття в умовах.",
    VERIFICATION_SUCCESS_RECEIVED_BODY:
      "Вашу страхову заявку з номером <strong>{bookingId}</strong> успішно прийнято. Незабаром лист підтвердження надійде на <strong>{policyHolderEmail}</strong>. Якщо листа немає, перевірте «Спам».",
    VERIFICATION_SUCCESS_THANKS: "Дякуємо за підтвердження електронної адреси.",
    VERIFICATION_SUCCESS_TITLE: "Вашу заявку обробляють",
    WHAT_IS_NEXT: "Що далі",
    WHAT_IS_NEXT_SUBMIT_TITLE: "Подати заявку",
    WHAT_IS_NEXT_SUBMIT_TEXT: "Ми отримали вашу заявку.",
    WHAT_IS_NEXT_PROGRESS_EMAIL_VALIDATION_TEXT:
      "Підтвердіть e-mail за посиланням у нашому листі.",
    WHAT_IS_NEXT_PROGRESS_SUBMISSION_TEXT:
      "Ми перевіряємо заявку та передаємо її далі.",
    WHAT_IS_NEXT_PROGRESS_PROCESSING_TEXT: "Страховик обробляє вашу заявку.",
    WHAT_IS_NEXT_PROGRESS_INSURANCE_POLICY_TEXT:
      "Страховик надсилає вам документи.",
    WHAT_DOES_IT_MEAN: "Що це означає?",
    WIZARD_SELECT_PLACEHOLDER: "Будь ласка, оберіть …",
    WIZARD_FORM_COMPLETE_TOAST: "Заповніть форму повністю.",
    WIZARD_INITIAL_INFO_CHECKBOX_TEXT:
      "Підтверджую, що завантажив(ла) та прочитав(ла) початкове розкриття для страхових посередників згідно з § 15 VersVermV.",
    WIZARD_INITIAL_INFO_REQUIRED:
      "Підтвердіть отримання початкового розкриття.",
    WIZARD_SUMMARY_EDIT: "Змінити",
    WIZARD_SUMMARY_TITLE: "Ваш пошук",
    UI_DISPLAY: "Вигляд",
    UI_DISPLAY_CURRENT: "Вигляд: {setting}",
    UI_THEME_CYCLE_TO: "Змінити колірну схему на {mode}",
    UI_THEME_LIGHT: "Світла",
    UI_THEME_DARK: "Темна",
    UI_THEME_AUTO: "Автоматично",
    UI_THEME_HIGH_CONTRAST_ENABLE: "Високий контраст",
    UI_THEME_HIGH_CONTRAST_DISABLE: "Звичайний контраст",
    UI_CONTRAST_TOGGLE_TO: "Змінити контраст на {mode}",
    UI_FONT_SIZE_LEVEL_0: "Стандартний",
    UI_FONT_SIZE_LEVEL_1: "Збільшений",
    UI_FONT_SIZE_LEVEL_2: "Максимальний",
    UI_FONT_SIZE_CYCLE_TO: "Змінити розмір шрифту на {size}",
    UI_LOADING: "Завантаження …",
    UI_FONT_SIZE_INCREASE: "Збільшити шрифт",
    UI_FONT_SIZE_DECREASE: "Зменшити шрифт",
    UPDATE_SESSION_SUCCESS_DESCRIPTION: "Ваші зміни збережено.",
    UPDATE_SESSION_SUCCESS_TITLE: "Зміни збережено",
    UPDATE_SESSION_ERROR_DESCRIPTION:
      "Не вдалося оновити чернетку заявки. Спробуйте ще раз.",
    CONTACT_WIDGET_DROPDOWN_TITLE: "Ваші контакти",
    LIVE_CHAT_OPEN_LABEL: "Відкрити live-чат",
    CONTACT_WIDGET_TOGGLE_LABEL: "Показати або приховати контактну інформацію",
    CONTACT_WIDGET_EMAIL_LABEL: "Електронна пошта",
    CONTACT_WIDGET_PHONE_LABEL: "Телефон",
    CONTACT_WIDGET_PHOTO_ALT: "Фото контакту",
    CONTACT_WIDGET_WEBSITE_LABEL: "Вебсайт",
    YOUR_CONTACT_PERSON: "Ваш контакт",
    YOUR_CONTRACT_NUM: "Ваша заявка",
    YOUR_DOCUMENTS: "Ваші документи",
    YOUR_RECORDS: "Ваші матеріали",
    YOUR_SELECTION: "Ваш вибір",
    YOUR_SEARCH_SELECTION: "Ваш пошуковий вибір",
    WHAT_IS_NEXT_EMAIL_VALIDATION_TITLE: "Підтвердіть електронну адресу",
    WHAT_IS_NEXT_EMAIL_VALIDATION_TEXT:
      "Будь ласка, підтвердіть свою електронну адресу за посиланням у листі, який ми надіслали на <strong>{email}</strong>. Лише після цього ми зможемо передати вашу заявку далі.",
  },
};
